var items = {
  "block.minecraft.air": "ﺍﻮﻫ",
  "block.minecraft.stone": "گﻨﺳ",
  "block.minecraft.granite": "ﺖیﻧﺍﺮگ",
  "block.minecraft.polished_granite": "ﻩﺩﺭﻮﺧ ﺵﺍﺮﺗ ﺖیﻧﺍﺮگ",
  "block.minecraft.diorite": "ﺖیﺭﻮیﺩ",
  "block.minecraft.polished_diorite": "ﻩﺩﺭﻮﺧ ﺵﺍﺮﺗ ﺖیﺭﻮیﺩ",
  "block.minecraft.andesite": "ﺖیﺯﺪﻧﺁ",
  "block.minecraft.polished_andesite": "ﻩﺩﺭﻮﺧ ﺵﺍﺮﺗ ﺖیﺯﺪﻧﺁ",
  "block.minecraft.grass_block": "ﻦﻤچ کﻮﻠﺑ",
  "block.minecraft.dirt": "کﺎﺧ",
  "block.minecraft.coarse_dirt": "یکﻫﺁ کﺎﺧ",
  "block.minecraft.podzol": "کﺎﺧﺎیگ",
  "block.minecraft.crimson_nylium": "ﻥﻮﺴﻤﻳﺮک ﻡﻮیﻠیﻧ",
  "block.minecraft.warped_nylium": "ﻩﺩﺭﻮﺧچیپ ﻡﻮیﻠیﻧ",
  "block.minecraft.cobblestone": "گﻨﺳ ﻩﻮﻠﻗ",
  "block.minecraft.oak_planks": "ﻁﻮﻠﺑ ﺭﺍﻮﻟﺍ",
  "block.minecraft.spruce_planks": "ﺝﺎک ﺭﺍﻮﻟﺍ",
  "block.minecraft.birch_planks": "ﺱﻮﺗ ﺭﺍﻮﻟﺍ",
  "block.minecraft.jungle_planks": "یﻠگﻨﺟ ﺭﺍﻮﻟﺍ",
  "block.minecraft.acacia_planks": "ﺎﻴﻗﺎﻗﺍ ﺭﺍﻮﻟﺍ",
  "block.minecraft.dark_oak_planks": "ﻩﺮﻴﺗ ﻁﻮﻠﺑ ﺭﺍﻮﻟﺍ",
  "block.minecraft.crimson_planks": "ﻥﻮﺴﻤﻳﺮک ﺭﺍﻮﻟﺍ",
  "block.minecraft.warped_planks": "ﻩﺩﺭﻮﺧچیپ ﺭﺍﻮﻟﺍ",
  "block.minecraft.oak_sapling": "ﻁﻮﻠﺑ ﺖﺧﺭﺩ ﻝﺎﻬﻧ",
  "block.minecraft.spruce_sapling": "ﺮﺑﻮﻨﺻ ﺖﺧﺭﺩ ﻝﺎﻬﻧ",
  "block.minecraft.birch_sapling": "ﺱﻮﺗ ﺖﺧﺭﺩ ﻝﺎﻬﻧ",
  "block.minecraft.jungle_sapling": "یﻠگﻨﺟ ﺖﺧﺭﺩ ﻝﺎﺤﻧ",
  "block.minecraft.acacia_sapling": "ﺎﻴﻗﺎﻗﺍ ﺖﺧﺭﺩ ﻝﺎﻬﻧ",
  "block.minecraft.dark_oak_sapling": "ﻩﺮﻴﺗ ﻁﻮﻠﺑ ﻝﺎﻬﻧ",
  "block.minecraft.bedrock": "ﺮﺘﺴﺑ گﻨﺳ",
  "block.minecraft.sand": "ﻪﺳﺎﻣ",
  "block.minecraft.red_sand": "ﺰﻣﺮﻗ ﻪﺳﺎﻣ",
  "block.minecraft.gravel": "گﻳﺭ",
  "block.minecraft.gold_ore": "ﻼﻃ ﻥﺪﻌﻣ گﻨﺳ",
  "block.minecraft.iron_ore": "ﻦﻫﺁ ﻥﺪﻌﻣ گﻨﺳ",
  "block.minecraft.coal_ore": "ﻝﺎﻏﺯ ﻥﺪﻌﻣ گﻨﺳ",
  "block.minecraft.nether_gold_ore": "ﺭﺪﻧ یﻼﻃ ﻥﺪﻌﻣ گﻨﺳ",
  "block.minecraft.oak_log": "ﻁﻮﻠﺑ ﺖﺧﺭﺩ ﻪﻨﺗ",
  "block.minecraft.spruce_log": "ﺝﺎک ﺖﺧﺭﺩ ﻪﻨﺗ",
  "block.minecraft.birch_log": "ﺱﻮﺗ ﺖﺧﺭﺩ ﻪﻨﺗ",
  "block.minecraft.jungle_log": "یﻠگﻨﺟ ﺏﻮچ ی ﻩﺪﻨک",
  "block.minecraft.acacia_log": "ﺎﻴﻗﺎﻗﺍ ﺖﺧﺭﺩ ﻪﻨﺗ",
  "block.minecraft.dark_oak_log": "ﻩﺮﻴﺗ ﻁﻮﻠﺑ ﺖﺧﺭﺩ ﻪﻨﺗ",
  "block.minecraft.crimson_stem": "ﻥﻮﺴﻤﻳﺮک ﻪﻗﺎﺳ",
  "block.minecraft.warped_stem": "ﻩﺩﺭﻮﺧچیپ ﻪﻗﺎﺳ",
  "block.minecraft.stripped_oak_log": "ﻁﻮﻠﺑ ﻪﻨﻫﺮﺑ ﻪﻨﺗ",
  "block.minecraft.stripped_spruce_log": "ﺝﺎک ﻪﻨﻫﺮﺑ ﻪﻨﺗ",
  "block.minecraft.stripped_birch_log": "ﺱﻮﺗ ﻪﻨﻫﺮﺑ ﻪﻨﺗ",
  "block.minecraft.stripped_jungle_log": "ﻩﺪﻨک ﺖﺳﻮپ یﻠگﻨﺟﺭﺍﻮﻟﺍ",
  "block.minecraft.stripped_acacia_log": "ﺎﻴﻗﺎﻗﺍ ﻪﻨﻫﺮﺑ ﻪﻨﺗ",
  "block.minecraft.stripped_dark_oak_log": "ﻩﺮﻴﺗ ﻁﻮﻠﺑ ﻪﻨﻫﺮﺑ ﻪﻨﺗ",
  "block.minecraft.stripped_crimson_stem": "ﻥﻮﺴﻤﻳﺮک ﻩﺪﻨکﺖﺳﻮپ ﻪﻨﺗ",
  "block.minecraft.stripped_warped_stem": "ﻩﺩﺭﻮﺧ چیپ ﻩﺪﻨکﺖﺳﻮپ ﻪﻨﺗ",
  "block.minecraft.stripped_oak_wood": "ﻁﻮﻠﺑ ﻪﻨﻫﺮﺑ ﺏﻮچ",
  "block.minecraft.stripped_spruce_wood": "ﺝﺎک ﻪﻨﻫﺮﺑ ﺏﻮچ",
  "block.minecraft.stripped_birch_wood": "ﺱﻮﺗ ﻪﻨﻫﺮﺑ ﺏﻮچ",
  "block.minecraft.stripped_jungle_wood": "ﻩﺪﻨک ﺖﺳﻮپ یﻠگﻨﺟ ﺏﻮچ",
  "block.minecraft.stripped_acacia_wood": "ﺎﻴﻗﺎﻗﺍ ﻪﻨﻫﺮﺑ ﺏﻮچ",
  "block.minecraft.stripped_dark_oak_wood": "ﻩﺎﻴﺳ ﻁﻮﻠﺑ ﻪﻨﻫﺮﺑ ﺏﻮچ",
  "block.minecraft.stripped_crimson_hyphae": "ﻥﻮﺴﻤﻳﺮک ﻩﺪﻨکﺖﺳﻮپ ﻪﺧﺎﺷﺮﺳ",
  "block.minecraft.stripped_warped_hyphae": "ﻩﺩﺭﻮﺧ چیپ ﻩﺪﻨکﺖﺳﻮپ ﻪﺧﺎﺷﺮﺳ",
  "block.minecraft.oak_wood": "ﻁﻮﻠﺑ ﺏﻮچ",
  "block.minecraft.spruce_wood": "ﺮﺑﻮﻨﺻ ﺏﻮچ",
  "block.minecraft.birch_wood": "ﺱﻮﺗ ﺏﻮچ",
  "block.minecraft.jungle_wood": "یﻠگﻨﺟ ﺏﻮچ",
  "block.minecraft.acacia_wood": "ﺎﻴﻗﺎﻗﺍ ﺏﻮچ",
  "block.minecraft.dark_oak_wood": "ﻩﺮﻴﺗ ﻁﻮﻠﺑ ﺏﻮچ",
  "block.minecraft.crimson_hyphae": "ﻥﻮﺴﻤﻳﺮک ﻪﺧﺎﺷﺮﺳ",
  "block.minecraft.warped_hyphae": "ﻩﺩﺭﻮﺧچیپ ﻪﺧﺎﺷﺮﺳ",
  "block.minecraft.oak_leaves": "ﻁﻮﻠﺑ گﺮﺑ",
  "block.minecraft.spruce_leaves": "ﺮﺑﻮﻨﺻ گﺮﺑ",
  "block.minecraft.birch_leaves": "ﺱﻮﺗ گﺮﺑ",
  "block.minecraft.jungle_leaves": "یﻠگﻨﺟ گﺮﺑ",
  "block.minecraft.acacia_leaves": "ﺎﻴﻗﺎﻗﺍ گﺮﺑ",
  "block.minecraft.dark_oak_leaves": "ﻩﺮﻴﺗ ﻁﻮﻠﺑ گﺮﺑ",
  "block.minecraft.sponge": "ﺞﻨﻔﺳﺍ",
  "block.minecraft.wet_sponge": "ﺲﻴﺧ ﺞﻨﻔﺳﺍ",
  "block.minecraft.glass": "ﻪﺸﻴﺷ",
  "block.minecraft.lapis_ore": "ﺩﺭﻮﺟﻻ ﻥﺪﻌﻣ گﻨﺳ",
  "block.minecraft.lapis_block": "ﺩﺭﻮﺟﻻ کﻮﻠﺑ",
  "block.minecraft.dispenser": "ﺮگﻌﻳﺯﻮﺗ",
  "block.minecraft.sandstone": "گﻨﺳ ﻪﺳﺎﻣ",
  "block.minecraft.chiseled_sandstone": "ﻩﺩﺭﻮﺧ ﺵﺍﺮﺗ گﻨﺳ ﻪﺳﺎﻣ",
  "block.minecraft.cut_sandstone": "ﻩﺩﺭﻮﺧ ﺵﺮﺑ گﻨﺳ ﻪﺳﺎﻣ",
  "block.minecraft.note_block": "ﺖﻧ کﻮﻠﺑ",
  "block.minecraft.powered_rail": "یﺘکﺮﺣ ﻞﻳﺭ",
  "block.minecraft.detector_rail": "ﻩﺪﻨﺑﺎﻳ ﻞﻳﺭ",
  "block.minecraft.sticky_piston": "کﺎﻨﺒﺴچ ﻥﻮﺘﺴﻴپ",
  "block.minecraft.cobweb": "ﺕﻮﺒکﻨﻋ ﺭﺎﺗ",
  "block.minecraft.grass": "ﻦﻤچ",
  "block.minecraft.fern": "ﺲﺧﺮﺳ ﻪﺗﻮﺑ",
  "block.minecraft.dead_bush": "کﺸﺧ ﻪﺘﺑ",
  "block.minecraft.seagrass": "یﻳﺎﻳﺭﺩ ﻒﻠﻋ",
  "block.minecraft.sea_pickle": "یﻳﺎﻳﺭﺩ ﺭﻮﺷﺭﺎیﺧ",
  "block.minecraft.piston": "ﻥﻮﺘﺴﻴپ",
  "block.minecraft.white_wool": "ﺪﻴﻔﺳ ﻢﺸپ",
  "block.minecraft.orange_wool": "ﻲﺠﻧﺭﺎﻧ ﻢﺸپ",
  "block.minecraft.magenta_wool": "ﻲﺑﺂﺧﺮﺳ ﻢﺸپ",
  "block.minecraft.light_blue_wool": "ﻲﻧﺎﻤﺳﺁ ﻲﺑﺁ ﻢﺸپ",
  "block.minecraft.yellow_wool": "ﺩﺭﺯ ﻢﺸپ",
  "block.minecraft.lime_wool": "ﻱﺮﻔﺴﻓ ﻢﺸپ",
  "block.minecraft.pink_wool": "ﻲﺗﺭﻮﺻ ﻢﺸپ",
  "block.minecraft.gray_wool": "ﻱﺮﺘﺴکﺎﺧ ﻢﺸپ",
  "block.minecraft.light_gray_wool": "ﻱﺍ ﻩﺮﻘﻧ ﻢﺸپ",
  "block.minecraft.cyan_wool": "ﻱﺍ ﻩﺯﻭﺮﻴﻓ ﻢﺸپ",
  "block.minecraft.purple_wool": "ﺶﻔﻨﺑ ﻢﺸپ",
  "block.minecraft.blue_wool": "ﻲﺑﺁ ﻢﺸپ",
  "block.minecraft.brown_wool": "ﻱﺍ ﻩﻮﻬﻗ ﻢﺸپ",
  "block.minecraft.green_wool": "ﺰﺒﺳ ﻢﺸپ",
  "block.minecraft.red_wool": "ﺰﻣﺮﻗ ﻢﺸپ",
  "block.minecraft.black_wool": "ﻲکﺸﻣ ﻢﺸپ",
  "block.minecraft.dandelion": "کﺪﺻﺎﻗ ﻞگ",
  "block.minecraft.poppy": "ﻖﻳﺎﻘﺷ ﻞگ",
  "block.minecraft.blue_orchid": "یﺑﺁ ﻩﺪﻴکﺭﺍ ﻞگ",
  "block.minecraft.allium": "ﺮﻴﺳﻞگ",
  "block.minecraft.azure_bluet": "ﺎﻴﻧﻮﺘﺳﺎﻫ ﻞگ",
  "block.minecraft.red_tulip": "ﺰﻣﺮﻗ ﻪﻟﻻ ﻞگ",
  "block.minecraft.orange_tulip": "یﺠﻧﺭﺎﻧ ﻪﻟﻻ ﻞگ",
  "block.minecraft.white_tulip": "ﺪﻴﻔﺳ ﻪﻟﻻ ﻞگ",
  "block.minecraft.pink_tulip": "یﺗﺭﻮﺻ ﻪﻟﻻ ﻞگ",
  "block.minecraft.oxeye_daisy": "ﺎﻨﻴﻣ ﻞگ",
  "block.minecraft.cornflower": "ﻡﺪﻨگﻞگ",
  "block.minecraft.lily_of_the_valley": "ﻖﺒﻧﺯ ﻞگ",
  "block.minecraft.wither_rose": "ﺭﺪﻳﻭ ﻞگ",
  "block.minecraft.brown_mushroom": "یﺍﻩﻮﻬﻗ چﺭﺎﻗ",
  "block.minecraft.red_mushroom": "ﺰﻣﺮﻗ چﺭﺎﻗ",
  "block.minecraft.crimson_fungus": "ﻥﻮﺴﻤﻳﺮک چﺭﺎﻗ",
  "block.minecraft.warped_fungus": "ﻩﺩﺭﻮﺧچیپ چﺭﺎﻗ",
  "block.minecraft.crimson_roots": "ﻥﻮﺴﻤﻳﺮک یﺎﻫ ﻪﺸیﺭ",
  "block.minecraft.warped_roots": "ﻩﺩﺭﻮﺧچیپ یﺎﻫ ﻪﺸیﺭ",
  "block.minecraft.nether_sprouts": "یﺭﺪﻧ ﻪﻧﺍﻮﺟ",
  "block.minecraft.weeping_vines": "ﻥﺎیﺮگ کچیپ",
  "block.minecraft.twisting_vines": "ﻩﺪﻨچیپ یﺎﻫ کﺎﺗ",
  "block.minecraft.sugar_cane": "ﺮکﺸیﻧ",
  "block.minecraft.kelp": "یﻳﺎﻳﺭﺩ کﺒﻠﺟ",
  "block.minecraft.bamboo": "ﻮﺒﻣﺎﺑ",
  "block.minecraft.gold_block": "ﻼﻃ کﻮﻠﺑ",
  "block.minecraft.iron_block": "ﻦﻫﺁ کﻮﻠﺑ",
  "block.minecraft.oak_slab": "ﻁﻮﻠﺑ ﻪﺘﺨﺗ",
  "block.minecraft.spruce_slab": "ﺝﺎک ﻪﺘﺨﺗ",
  "block.minecraft.birch_slab": "ﺱﻮﺗ ﻪﺘﺨﺗ",
  "block.minecraft.jungle_slab": "یﻠگﻨﺟ ﻪﺘﺨﺗ",
  "block.minecraft.acacia_slab": "ﺎﻴﻗﺎﻗﺍ ﻪﺘﺨﺗ",
  "block.minecraft.dark_oak_slab": "ﻩﺮﻴﺗ ﻁﻮﻠﺑ ﻪﺘﺨﺗ",
  "block.minecraft.crimson_slab": "ﻥﻮﺴﻤﻳﺮک کﻮﻠﺑ ﻪﻤﻴﻧ",
  "block.minecraft.warped_slab": "ﻩﺩﺭﻮﺧچیپ کﻮﻠﺑ ﻪﻤﻴﻧ",
  "block.minecraft.stone_slab": "ﻲگﻨﺳ ﻪﻌﻄﻗ",
  "block.minecraft.smooth_stone_slab": "ﻩﺪﺷ ﻒﺼﻧ یﻠﻘﻴﺻ گﻨﺳ",
  "block.minecraft.sandstone_slab": "گﻨﺳ ﻪﺳﺎﻣ ﻪﻤﻴﻧ",
  "block.minecraft.cut_sandstone_slab": "ﻩﺩﺭﻮﺧ ﺵﺮﺑ گﻨﺳ ﻪﺳﺎﻣ ﻪﻤﻴﻧ",
  "block.minecraft.petrified_oak_slab": "ﻩﺪﺷ کﺸﺧ ﻁﻮﻠﺑ ﻪﺘﺨﺗ",
  "block.minecraft.cobblestone_slab": "ﻲگﻨﺳ ﻩﻮﻠﻗ ﻪﻌﻄﻗ",
  "block.minecraft.brick_slab": "ﺮﺟﺁ ﻪﺘﺨﺗ",
  "block.minecraft.stone_brick_slab": "یگﻨﺳ ﺮﺟﺁ ﻪﺘﺨﺗ",
  "block.minecraft.nether_brick_slab": "ﺭﺪﻧ ﺮﺟﺁ ﻪﻌﻄﻗ",
  "block.minecraft.quartz_slab": "ﻱﺰﺗﺭﺍﻮک ﻪﻌﻄﻗ",
  "block.minecraft.red_sandstone_slab": "ﺰﻣﺮﻗ گﻨﺳ ﻪﺳﺎﻣ ﻪﻤﻴﻧ",
  "block.minecraft.cut_red_sandstone_slab": "ﻩﺩﺭﻮﺧ ﺵﺮﺑ ﺰﻣﺮﻗ گﻨﺳ ﻪﺳﺎﻣ ﻪﻤﻴﻧ",
  "block.minecraft.purpur_slab": "ﺭﻮپ ﺭﻮپ ﻪﻌﻄﻗ",
  "block.minecraft.prismarine_slab": "یﻳﺎﻳﺭﺩ ﺭﻮﺸﻨﻣ ﻪﺘﺨﺗ",
  "block.minecraft.prismarine_brick_slab": "یﻳﺎﻳﺭﺩ ﺭﻮﺸﻨﻣ ﺮﺟﺁ ﻪﺘﺨﺗ",
  "block.minecraft.dark_prismarine_slab": "ﻩﺮﻴﺗ یﻳﺎﻳﺭﺩ ﺭﻮﺸﻨﻣ ﻪﺘﺨﺗ",
  "block.minecraft.smooth_quartz": "ﻑﺎﺻ ﺰﺗﺭﺍﻮک کﻮﻠﺑ",
  "block.minecraft.smooth_red_sandstone": "ﻑﺎﺻ ﺰﻣﺮﻗ گﻨﺳ ﻪﺳﺎﻣ",
  "block.minecraft.smooth_sandstone": "ﻑﺎﺻ گﻨﺳ ﻪﺳﺎﻣ",
  "block.minecraft.smooth_stone": "ﻑﺎﺻ گﻨﺳ",
  "block.minecraft.bricks": "ﺮﺟﺁ کﻮﻠﺑ",
  "block.minecraft.tnt": "ﻲﺗ ﻥﺍ ﻲﺗ",
  "block.minecraft.bookshelf": "ﺏﺎﺘک ﻪﺴﻔﻗ",
  "block.minecraft.mossy_cobblestone": "ﻩﺩﺯﻩﺰﺧ گﻨﺳ ﻩﻮﻠﻗ",
  "block.minecraft.obsidian": "ﻥﺎﻳﺪﻴﺴﺑﺁ",
  "block.minecraft.torch": "ﻞﻌﺸﻣ",
  "block.minecraft.end_rod": "ﻡﺎﺟﺮﻓ ﻪﻠیﻣ",
  "block.minecraft.chorus_plant": "ﺮک ﻩﺎیگ",
  "block.minecraft.chorus_flower": "ﺮک ﻞگ",
  "block.minecraft.purpur_block": "ﺭﻮپ ﺭﻮپ کﻮﻠﺑ",
  "block.minecraft.purpur_pillar": "یﻧﻮﺘﺳ ﺭﻮپ ﺭﻮپ کﻮﻠﺑ",
  "block.minecraft.purpur_stairs": "ﺮپﺮپ ﻪﻠپ",
  "block.minecraft.spawner": "ﻩﺪﻨﻨک ﺪیﻟﻮﺗ",
  "block.minecraft.oak_stairs": "ﻁﻮﻠﺑ ﻪﻠپ",
  "block.minecraft.chest": "ﻪچﻗﻭﺪﻨﺻ",
  "block.minecraft.diamond_ore": "ﺱﺎﻤﻟﺍ ﻥﺪﻌﻣ گﻨﺳ",
  "block.minecraft.diamond_block": "ﺱﺎﻤﻟﺍ کﻮﻠﺑ",
  "block.minecraft.crafting_table": "ﺭﺎکﺰﻴﻣ",
  "block.minecraft.farmland": "ﻪﻋﺭﺰﻣ کﺎﺧ",
  "block.minecraft.furnace": "ﻕﺎﺟﺍ",
  "block.minecraft.ladder": "ﻥﺎﺑﺩﺮﻧ",
  "block.minecraft.rail": "ﻞیﺭ",
  "block.minecraft.cobblestone_stairs": "ﻲگﻨﺳ ﻩﻮﻠﻗ ﻪﻠپ",
  "block.minecraft.lever": "ﻡﺮﻫﺍ",
  "block.minecraft.stone_pressure_plate": "یگﻨﺳ یﺭﺎﺸﻓ ﻪﺤﻔﺻ",
  "block.minecraft.oak_pressure_plate": "ﻁﻮﻠﺑ یﺭﺎﺸﻓ ﻪﺤﻔﺻ",
  "block.minecraft.spruce_pressure_plate": "ﺝﺎک یﺭﺎﺸﻓ ﻪﺤﻔﺻ",
  "block.minecraft.birch_pressure_plate": "ﺱﻮﺗ یﺭﺎﺸﻓ ﻪﺤﻔﺻ",
  "block.minecraft.jungle_pressure_plate": "یﻠگﻨﺟ یﺭﺎﺸﻓ ﻪﺤﻔﺻ",
  "block.minecraft.acacia_pressure_plate": "ﺎﻴﻗﺎﻗﺍ یﺭﺎﺸﻓ ﻪﺤﻔﺻ",
  "block.minecraft.dark_oak_pressure_plate": "ﻩﺮﻴﺗ ﻁﻮﻠﺑ یﺭﺎﺸﻓ ﻪﺤﻔﺻ",
  "block.minecraft.crimson_pressure_plate": "ﻥﻮﺴﻤﻳﺮک یﺭﺎﺸﻓ ﻪﺤﻔﺻ",
  "block.minecraft.warped_pressure_plate": "ﻩﺩﺭﻮﺧچیپ یﺭﺎﺸﻓ ﻪﺤﻔﺻ",
  "block.minecraft.polished_blackstone_pressure_plate": "یﻠﻘﻴﺻ گﻨﺳﻩﺎﻴﺳ یﺭﺎﺸﻓ ﻪﺤﻔﺻ",
  "block.minecraft.redstone_ore": "ﻥﻮﺘﺳﺩﺭ ﻥﺪﻌﻣ گﻨﺳ",
  "block.minecraft.redstone_torch": "یﻧﻮﺘﺳﺩﺭ ﻞﻌﺸﻣ",
  "block.minecraft.snow": "ﻑﺮﺑ",
  "block.minecraft.ice": "ﺦﻳ",
  "block.minecraft.snow_block": "ﻑﺮﺑ کﻮﻠﺑ",
  "block.minecraft.cactus": "ﺱﻮﺘکﺎک",
  "block.minecraft.clay": "ﺱﺭ کﺎﺧ",
  "block.minecraft.jukebox": "ﻲﻘﻴﺳﻮﻣ ﻪﺒﻌﺟ",
  "block.minecraft.oak_fence": "یﺑﻮچ ﻩﺩﺮﻧ",
  "block.minecraft.spruce_fence": "ﺝﺎک ﻩﺩﺮﻧ",
  "block.minecraft.birch_fence": "ﺱﻮﺗ ﻩﺩﺮﻧ",
  "block.minecraft.jungle_fence": "یﻠگﻨﺟ ﻩﺩﺮﻧ",
  "block.minecraft.acacia_fence": "ﺎﻴﻗﺎﻗﺍ ﻩﺩﺮﻧ",
  "block.minecraft.dark_oak_fence": "ﻩﺮﻴﺗ ﻁﻮﻠﺑ ﻩﺩﺮﻧ",
  "block.minecraft.crimson_fence": "ﻥﻮﺴﻤﻳﺮک ﻩﺩﺮﻧ",
  "block.minecraft.warped_fence": "ﻩﺩﺭﻮﺧچیپ ﻩﺩﺮﻧ",
  "block.minecraft.pumpkin": "ﻞﺒﻨﺗﻭﺪک",
  "block.minecraft.carved_pumpkin": "ﻩﺪﺷ ﻩﺪیﺷﺍﺮﺗ ﻞﺒﻨﺗ ﻭﺪک",
  "block.minecraft.netherrack": "ﺭﺪﻧ گﻨﺳ",
  "block.minecraft.soul_sand": "ﺡﺍﻭﺭﺍ ﻦﺷ",
  "block.minecraft.soul_soil": "ﺡﺍﻭﺭﺍ کﺎﺧ",
  "block.minecraft.basalt": "ﺖﻟﺍﺯﺎﺑ",
  "block.minecraft.polished_basalt": "یﻠﻘﻴﺻ ﺖﻟﺍﺯﺎﺑ",
  "block.minecraft.soul_torch": "ﺡﻭﺭ ﻞﻌﺸﻣ",
  "block.minecraft.glowstone": "ﺎﻨﺷﻭﺭ گﻨﺳ",
  "block.minecraft.jack_o_lantern": "یﻧﺍﺭﻮﻧ ﻞﺒﻨﺗﻭﺪک",
  "block.minecraft.oak_trapdoor": "یﻃﻮﻠﺑ یﻪچﻳﺭﺩ",
  "block.minecraft.spruce_trapdoor": "ﺝﺎک یﻪچﻳﺭﺩ",
  "block.minecraft.birch_trapdoor": "یﺳﻮﺗ یﻪچﻳﺭﺩ",
  "block.minecraft.jungle_trapdoor": "یﻠگﻨﺟ یﻪچﻳﺭﺩ",
  "block.minecraft.acacia_trapdoor": "ﺎﻴﻗﺎﻗﺍ یﻪچﻳﺭﺩ",
  "block.minecraft.dark_oak_trapdoor": "ﻩﺮﻴﺗ ﻁﻮﻠﺑ یﻪچﻳﺭﺩ",
  "block.minecraft.crimson_trapdoor": "ﻥﻮﺴﻤﻳﺮک یﻪچﻳﺭﺩ",
  "block.minecraft.warped_trapdoor": "ﻩﺩﺭﻮﺧچیپ یﻪچﻳﺭﺩ",
  "block.minecraft.infested_stone": "ﻩﺩﺯ ﺖﻓﺁ گﻨﺳ",
  "block.minecraft.infested_cobblestone": "ﻩﺩﺯ ﺖﻓﺁ گﻨﺳ ﻩﻮﻠﻗ",
  "block.minecraft.infested_stone_bricks": "ﻩﺩﺯ ﺖﻓﺁ گﻨﺳ ﺮﺟﺁ",
  "block.minecraft.infested_mossy_stone_bricks": "ﻩﺩﺯ ﺖﻓﺁ یﺍ ﻩﺰﺧ گﻨﺳ ﺮﺟﺁ",
  "block.minecraft.infested_cracked_stone_bricks": "ﻩﺩﺮﺧ کﺮﺗ ۀﺩﺯ ﺖﻓﺁ گﻨﺳ ﺮﺟﺁ",
  "block.minecraft.infested_chiseled_stone_bricks": "ﻩﺪﺷ ﻩﺪیﺷﺍﺮﺗ ۀﺩﺯ ﺖﻓﺁ گﻨﺳ ﺮﺟﺁ",
  "block.minecraft.stone_bricks": "گﻨﺳﺮﺟﺁ",
  "block.minecraft.mossy_stone_bricks": "ﻲﻨﺠﻟ گﻨﺳﺮﺟﺁ",
  "block.minecraft.cracked_stone_bricks": "ﻪﺘﺴکﺷ گﻨﺳﺮﺟﺁ",
  "block.minecraft.chiseled_stone_bricks": "ﻲﺷﺍﺮﺗ گﻨﺳﺮﺟﺁ",
  "block.minecraft.brown_mushroom_block": "یﺍﻩﻮﻬﻗ چﺭﺎﻗ کﻮﻠﺑ",
  "block.minecraft.red_mushroom_block": "ﺰﻣﺮﻗ چﺭﺎﻗ کﻮﻠﺑ",
  "block.minecraft.mushroom_stem": "چﺭﺎﻗ ﻪﻗﺎﺳ",
  "block.minecraft.iron_bars": "ﻲﻨﻫﺁ ﻱﺎﻫ ﻪﻠﻴﻣ",
  "block.minecraft.chain": "ﺮیﺠﻧﺯ",
  "block.minecraft.glass_pane": "ﻩﺮﺠﻨپ ﻪﺸﻴﺷ",
  "block.minecraft.melon": "ﻪﻧﺍﻭﺪﻨﻫ",
  "block.minecraft.vine": "ﺎﻫ کﺎﺗ",
  "block.minecraft.oak_fence_gate": "ﻲﺑﻮچ ﻩﺯﺍﻭﺭﺩ",
  "block.minecraft.spruce_fence_gate": "ﺝﺎک ﻩﺩﺮﻧ ﺏﺭﺩ",
  "block.minecraft.birch_fence_gate": "ﺱﻮﺗ ﻩﺩﺮﻧ ﺏﺭﺩ",
  "block.minecraft.jungle_fence_gate": "یﻠگﻨﺟ ﻩﺩﺮﻧ ﺏﺭﺩ",
  "block.minecraft.acacia_fence_gate": "ﺎﻴﻗﺎﻗﺍ ﻩﺩﺮﻧ ﺏﺭﺩ",
  "block.minecraft.dark_oak_fence_gate": "ﻩﺮﻴﺗ ﻁﻮﻠﺑ ﻩﺩﺮﻧ ﺏﺭﺩ",
  "block.minecraft.crimson_fence_gate": "ﻥﻮﺴﻤﻳﺮک ﻩﺩﺮﻧ ﺏﺭﺩ",
  "block.minecraft.warped_fence_gate": "ﻩﺩﺭﻮﺧچیپ ﻩﺩﺮﻧ ﺏﺭﺩ",
  "block.minecraft.brick_stairs": "ﻱﺮﺟﺁ ﻪﻠپ",
  "block.minecraft.stone_brick_stairs": "ﻲگﻨﺳﺮﺟﺁ ﻪﻠپ",
  "block.minecraft.mycelium": "کﺎﺨچﺭﺎﻗ",
  "block.minecraft.lily_pad": "ﻲﻳﺎﻳﺭﺩ ﻖﺒﻧﺯ",
  "block.minecraft.nether_bricks": "ﺭﺪﻧ ﺮﺟﺁ",
  "block.minecraft.cracked_nether_bricks": "ﻩﺩﺭﻮﺧکﺮﺗ یﺭﺪﻧ ﺮﺟﺁ",
  "block.minecraft.chiseled_nether_bricks": "ﻩﺩﺭﻮﺧﺵﺍﺮﺗ یﺭﺪﻧ ﺮﺟﺁ",
  "block.minecraft.nether_brick_fence": "ﺭﺪﻧ ﺭﺎﺼﺣ",
  "block.minecraft.nether_brick_stairs": "ﺭﺪﻧ ﺮﺟﺁ ﻪﻠپ",
  "block.minecraft.enchanting_table": "یﺮگﻧﻮﺴﻓﺍ ﺰﻴﻣ",
  "block.minecraft.end_portal_frame": "ﻡﺎﺟﺮﻓ ﻩﺎگﺭﺩ ﺏﻮچﺭﺎچ",
  "block.minecraft.end_stone": "ﻡﺎﺟﺮﻓ گﻨﺳ",
  "block.minecraft.end_stone_bricks": "ﺪﻧﺍ گﻨﺳ ﺮﺟﺁ",
  "block.minecraft.dragon_egg": "ﺎﻫﺩژﺍ ﻢﺨﺗ",
  "block.minecraft.redstone_lamp": "یﻧﻮﺘﺳﺩﺭ پﻣﻻ",
  "block.minecraft.sandstone_stairs": "ﻲگﻨﺳ ﻪﺳﺎﻣ ﻪﻠپ",
  "block.minecraft.emerald_ore": "ﺩﺮﻣﺯ ﻥﺪﻌﻣ گﻨﺳ",
  "block.minecraft.ender_chest": "ﻡﺎﺟﺮﻓ ﻪچﻗﻭﺪﻨﺻ",
  "block.minecraft.tripwire_hook": "یﺨﻧ ﻪﻠﺗ ﻩﺮیگ",
  "block.minecraft.emerald_block": "ﺩﺮﻣﺯ کﻮﻠﺑ",
  "block.minecraft.spruce_stairs": "ﺝﺎک ﻪﻠپ",
  "block.minecraft.birch_stairs": "ﺱﻮﺗ ﻪﻠپ",
  "block.minecraft.jungle_stairs": "یﻠگﻨﺟ ﺏﻮﺟ ﻪﻠپ",
  "block.minecraft.crimson_stairs": "ﻥﻮﺴﻤﻳﺮک ﻪﻠپ",
  "block.minecraft.warped_stairs": "ﻩﺩﺭﻮﺧچیپ یﺎﻫﻪﻠپ",
  "block.minecraft.command_block": "ﺭﻮﺘﺳﺩ کﻮﻠﺑ",
  "block.minecraft.beacon": "ﺱﻮﻧﺎﻓ",
  "block.minecraft.cobblestone_wall": "گﻨﺳ ﻩﻮﻠﻗ ﺭﺍﻮﻳﺩ",
  "block.minecraft.mossy_cobblestone_wall": "ﻲﻨﺠﻟ گﻨﺳ ﻩﻮﻠﻗ ﺭﺍﻮﻳﺩ",
  "block.minecraft.brick_wall": "یﺮﺟﺁ ﺭﺍﻮﻳﺩ",
  "block.minecraft.prismarine_wall": "ﻦیﺭﺎﻤﺴیﺮپ ﺭﺍﻮﻳﺩ",
  "block.minecraft.red_sandstone_wall": "ﺰﻣﺮﻗ گﻨﺳ ﻪﺳﺎﻣ ﺭﺍﻮﻳﺩ",
  "block.minecraft.mossy_stone_brick_wall": "ﻪﺘﻓﺮگ ﻩﺰﺧ یگﻨﺳ ﺮﺟﺁ ﺭﺍﻮﻳﺩ",
  "block.minecraft.granite_wall": "ﺖیﻧﺍﺮگ ﺭﺍﻮﻳﺩ",
  "block.minecraft.stone_brick_wall": "یگﻨﺳ ﺮﺟﺁ ﺭﺍﻮﻳﺩ",
  "block.minecraft.nether_brick_wall": "ﺭﺪﻧ ﺮﺟﺁ ﺭﺍﻮﻳﺩ",
  "block.minecraft.andesite_wall": "ﺖیﺯﺪﻧﺁ ﺭﺍﻮﻳﺩ",
  "block.minecraft.red_nether_brick_wall": "ﺰﻣﺮﻗ یﺭﺪﻧ ﺮﺟﺁ ﺭﺍﻮﻳﺩ",
  "block.minecraft.sandstone_wall": "ﻲگﻨﺳ ﻪﺳﺎﻣ ﺭﺍﻮﻳﺩ",
  "block.minecraft.end_stone_brick_wall": "ﺪﻧﺍ گﻨﺳ ﺮﺟﺁ ﺭﺍﻮﻳﺩ",
  "block.minecraft.diorite_wall": "ﺖیﺭﻮیﺩ ﺭﺍﻮﻳﺩ",
  "block.minecraft.blackstone_wall": "گﻨﺳ ﻩﺎﻴﺳ ﺭﺍﻮﻳﺩ",
  "block.minecraft.polished_blackstone_wall": "یﻠﻘﻴﺻ گﻨﺳﻩﺎﻴﺳ ﺭﺍﻮﻳﺩ",
  "block.minecraft.polished_blackstone_brick_wall": "یﻠﻘﻴﺻ گﻨﺳﻩﺎﻴﺳ ﺮﺟﺁ ﺭﺍﻮﻳﺩ",
  "block.minecraft.stone_button": "یگﻨﺳ ﻪﻤکﺩ",
  "block.minecraft.oak_button": "یﻃﻮﻠﺑ ﻪﻤکﺩ",
  "block.minecraft.spruce_button": "ﺝﺎک ﻪﻤکﺩ",
  "block.minecraft.birch_button": "یﺳﻮﺗ ﻪﻤکﺩ",
  "block.minecraft.jungle_button": "یﻠگﻨﺟ ﻪﻤکﺩ",
  "block.minecraft.acacia_button": "ییﺎﻴﻗﺎﻗﺍ ﻪﻤکﺩ",
  "block.minecraft.dark_oak_button": "ﻩﺮﻴﺗ ﻁﻮﻠﺑ ﻪﻤکﺩ",
  "block.minecraft.crimson_button": "ﻥﻮﺴﻤﻳﺮک ﻪﻤکﺩ",
  "block.minecraft.warped_button": "ﻩﺩﺭﻮﺧچیپ یﻪﻤکﺩ",
  "block.minecraft.polished_blackstone_button": "یﻠﻘﻴﺻ گﻨﺳﻩﺎﻴﺳ یﻪﻤکﺩ",
  "block.minecraft.anvil": "ﻥﺍﺪﻨﺳ",
  "block.minecraft.chipped_anvil": "ﻪﺘﺷﺍﺩﺮﺑ کﺮﺗ ﹺﻥﺍﺪﻨﺳ",
  "block.minecraft.damaged_anvil": "ﻩﺪیﺩ ﺐﻴﺳﺁ ﻥﺍﺪﻨﺳ",
  "block.minecraft.trapped_chest": "ﻱﺭﺍﺬگ ﻪﻠﺗ ﻪچﻗﻭﺪﻨﺻ",
  "block.minecraft.light_weighted_pressure_plate": "ﻥﺯﻭ کﺒﺳ یﺭﺎﺸﻓ ﻪﺤﻔﺻ",
  "block.minecraft.heavy_weighted_pressure_plate": "ﻥﺯﻭ ﻦیگﻨﺳ یﺭﺎﺸﻓ ﻪﺤﻔﺻ",
  "block.minecraft.daylight_detector": "ﺭﻮﻧ ﺭﻮﺴﻨﺳ",
  "block.minecraft.redstone_block": "ﻥﻮﺘﺳﺩﺭ کﻮﻠﺑ",
  "block.minecraft.nether_quartz_ore": "ﺭﺪﻧ ﺰﺗﺭﺍﻮک ﻥﺪﻌﻣ گﻨﺳ",
  "block.minecraft.hopper": "ﻒﻴﻗ",
  "block.minecraft.chiseled_quartz_block": "ﻲﺷﺍﺮﺗ ﺰﺗﺭﺍﻮک کﻮﻠﺑ",
  "block.minecraft.quartz_block": "ﺰﺗﺭﺍﻮک کﻮﻠﺑ",
  "block.minecraft.quartz_bricks": "یﺰﺗﺭﺍﻮک ﺮﺟﺁ",
  "block.minecraft.quartz_pillar": "ﺰﺗﺭﺍﻮک ﻥﻮﺘﺳ",
  "block.minecraft.quartz_stairs": "ﺰﺗﺭﺍﻮک ﻪﻠپ",
  "block.minecraft.activator_rail": "ﺯﺎﺴﻟﺎﻌﻓ ﻞیﺭ",
  "block.minecraft.dropper": "ﺮگﺑﺎﺗﺮپ",
  "block.minecraft.white_terracotta": "ﺪﻴﻔﺳ ﻝﺎﻔﺳ",
  "block.minecraft.orange_terracotta": "یﺠﻧﺭﺎﻧ ﻝﺎﻔﺳ",
  "block.minecraft.magenta_terracotta": "یﻧﺍﻮﻏﺭﺍ ﻝﺎﻔﺳ",
  "block.minecraft.light_blue_terracotta": "ﻦﺷﻭﺭ یﺑﺁ ﻝﺎﻔﺳ",
  "block.minecraft.yellow_terracotta": "ﺩﺭﺯ ﻝﺎﻔﺳ",
  "block.minecraft.lime_terracotta": "ﻦﺷﻭﺭ ﺰﺒﺳ ﻝﺎﻔﺳ",
  "block.minecraft.pink_terracotta": "یﺗﺭﻮﺻ ﻝﺎﻔﺳ",
  "block.minecraft.gray_terracotta": "یﺮﺘﺴکﺎﺧ ﻝﺎﻔﺳ",
  "block.minecraft.light_gray_terracotta": "ﻦﺷﻭﺭ یﺮﺘﺴکﺎﺧ ﻝﺎﻔﺳ",
  "block.minecraft.cyan_terracotta": "یﺍﻩﺯﻭﺮﻴﻓ ﻝﺎﻔﺳ",
  "block.minecraft.purple_terracotta": "ﺶﻔﻨﺑ ﻝﺎﻔﺳ",
  "block.minecraft.blue_terracotta": "یﺑﺁ ﻝﺎﻔﺳ",
  "block.minecraft.brown_terracotta": "یﺍﻩﻮﻬﻗ ﻝﺎﻔﺳ",
  "block.minecraft.green_terracotta": "ﺰﺒﺳ ﻝﺎﻔﺳ",
  "block.minecraft.red_terracotta": "ﺰﻣﺮﻗ ﻝﺎﻔﺳ",
  "block.minecraft.black_terracotta": "ﻩﺎﻴﺳ ﻝﺎﻔﺳ",
  "block.minecraft.barrier": "ﻊﻧﺎﻣ",
  "block.minecraft.iron_trapdoor": "یﻨﻫﺁ ﻪچﻳﺭﺩ",
  "block.minecraft.hay_block": "ﻡﺪﻨگ کﻮﻠﺑ",
  "block.minecraft.white_carpet": "ﺪﻴﻔﺳ ﺵﺮﻓ",
  "block.minecraft.orange_carpet": "یﺠﻧﺭﺎﻧ ﺵﺮﻓ",
  "block.minecraft.magenta_carpet": "یﻧﺍﻮﻏﺭﺍ ﺵﺮﻓ",
  "block.minecraft.light_blue_carpet": "ﻦﺷﻭﺭ یﺑﺁ ﺵﺮﻓ",
  "block.minecraft.yellow_carpet": "ﺩﺭﺯ ﺵﺮﻓ",
  "block.minecraft.lime_carpet": "ﻦﺷﻭﺭ ﺰﺒﺳ ﺵﺮﻓ",
  "block.minecraft.pink_carpet": "یﺗﺭﻮﺻ ﺵﺮﻓ",
  "block.minecraft.gray_carpet": "یﺮﺘﺴکﺎﺧ ﺵﺮﻓ",
  "block.minecraft.light_gray_carpet": "یﺍﻩﺮﻘﻧ ﺵﺮﻓ",
  "block.minecraft.cyan_carpet": "یﺍﻩﺯﻭﺮﻴﻓ ﺵﺮﻓ",
  "block.minecraft.purple_carpet": "ﺶﻔﻨﺑ ﺵﺮﻓ",
  "block.minecraft.blue_carpet": "یﺑﺁ ﺵﺮﻓ",
  "block.minecraft.brown_carpet": "یﺍﻩﻮﻬﻗ ﺵﺮﻓ",
  "block.minecraft.green_carpet": "ﺰﺒﺳ ﺵﺮﻓ",
  "block.minecraft.red_carpet": "ﺰﻣﺮﻗ ﺵﺮﻓ",
  "block.minecraft.black_carpet": "ﻩﺎﻴﺳ ﺵﺮﻓ",
  "block.minecraft.terracotta": "ﻝﺎﻔﺳ",
  "block.minecraft.coal_block": "گﻨﺳ ﻝﺎﻏﺫ کﻮﻠﺑ",
  "block.minecraft.packed_ice": "ﻩﺩﺮﺸﻓ ﺦﻳ",
  "block.minecraft.acacia_stairs": "ﺎﻴﻗﺎﻗﺍ ﻪﻠپ",
  "block.minecraft.dark_oak_stairs": "ﻩﺮﻴﺗ ﻁﻮﻠﺑ ﻪﻠپ",
  "block.minecraft.slime_block": "ﻦﺠﻟ کﻮﻠﺑ",
  "block.minecraft.grass_path": "ﻦﻤچ ﻩﺍﺭ",
  "block.minecraft.sunflower": "ﻥﺍﺩﺮگﺑﺎﺘﻓﺁ ﻞگ",
  "block.minecraft.lilac": "ﺱﺎﻳ ﻞگ",
  "block.minecraft.rose_bush": "ﺯﺭ ﻪﺗﻮﺑ",
  "block.minecraft.peony": "ﺎﻴﻧﻮﻴپ ﻞگ",
  "block.minecraft.tall_grass": "ﺪﻨﻠﺑ ﻒﻠﻋ",
  "block.minecraft.large_fern": "گﺭﺰﺑ ﺲﺧﺮﺳ",
  "block.minecraft.white_stained_glass": "گﻧﺭ ﺪﻴﻔﺳ ﻪﺸﻴﺷ",
  "block.minecraft.orange_stained_glass": "گﻧﺭ یﺠﻧﺭﺎﻧ ﻪﺸﻴﺷ",
  "block.minecraft.magenta_stained_glass": "یﻧﺍﻮﻏﺭﺍ ﻪﺸﻴﺷ",
  "block.minecraft.light_blue_stained_glass": "ﻦﺷﻭﺭ یﺑﺁ گﻧﺭ ﻪﺸﻴﺷ",
  "block.minecraft.yellow_stained_glass": "گﻧﺭ ﺩﺭﺯ ﻪﺸﻴﺷ",
  "block.minecraft.lime_stained_glass": "ﻦﺷﻭﺭ ﺰﺒﺳ گﻧﺭ ﻪﺸﻴﺷ",
  "block.minecraft.pink_stained_glass": "گﻧﺭ یﺗﺭﻮﺻ ﻪﺸﻴﺷ",
  "block.minecraft.gray_stained_glass": "گﻧﺭ یﺮﺘﺴکﺎﺧ ﻪﺸﻴﺷ",
  "block.minecraft.light_gray_stained_glass": "گﻧﺭ یﺍﻩﺮﻘﻧ ﻪﺸﻴﺷ",
  "block.minecraft.cyan_stained_glass": "گﻧﺭ یﺍﻩﺯﻭﺮﻴﻓ ﻪﺸﻴﺷ",
  "block.minecraft.purple_stained_glass": "گﻧﺭ ﺶﻔﻨﺑ ﻪﺸﻴﺷ",
  "block.minecraft.blue_stained_glass": "گﻧﺭ یﺑﺁ ﻪﺸﻴﺷ",
  "block.minecraft.brown_stained_glass": "یﺍﻩﻮﻬﻗ گﻧﺭ ﻪﺸﻴﺷ",
  "block.minecraft.green_stained_glass": "گﻧﺭ ﺰﺒﺳ ﻪﺸﻴﺷ",
  "block.minecraft.red_stained_glass": "گﻧﺭ ﺰﻣﺮﻗ ﻪﺸﻴﺷ",
  "block.minecraft.black_stained_glass": "گﻧﺭ ﻩﺎﻴﺳ ﻪﺸﻴﺷ",
  "block.minecraft.white_stained_glass_pane": "گﻧﺭ ﺪﻴﻔﺳ ﻩﺮﺠﻨپ ﻪﺸﻴﺷ",
  "block.minecraft.orange_stained_glass_pane": "گﻧﺭ یﺠﻧﺭﺎﻧ ﻩﺮﺠﻨپ ﻪﺸﻴﺷ",
  "block.minecraft.magenta_stained_glass_pane": "گﻧﺭ یﻧﺍﻮﻏﺭﺍ ﻩﺮﺠﻨپ ﻪﺸﻴﺷ",
  "block.minecraft.light_blue_stained_glass_pane": "ﻦﺷﻭﺭ یﺑﺁ گﻧﺭ ﻩﺮﺠﻨپ ﻪﺸﻴﺷ",
  "block.minecraft.yellow_stained_glass_pane": "گﻧﺭ ﺩﺭﺯ ﻩﺮﺠﻨپ ﻪﺸﻴﺷ",
  "block.minecraft.lime_stained_glass_pane": "ﻦﺷﻭﺭ ﺰﺒﺳ گﻧﺭ ﻩﺮﺠﻨپ ﻪﺸﻴﺷ",
  "block.minecraft.pink_stained_glass_pane": "گﻧﺭ یﺗﺭﻮﺻ ﻩﺮﺠﻨپ ﻪﺸﻴﺷ",
  "block.minecraft.gray_stained_glass_pane": "گﻧﺭ یﺮﺘﺴکﺎﺧ ﻩﺮﺠﻨپ ﻪﺸﻴﺷ",
  "block.minecraft.light_gray_stained_glass_pane": "گﻧﺭ یﺍﻩﺮﻘﻧ ﻩﺮﺠﻨپ ﻪﺸﻴﺷ",
  "block.minecraft.cyan_stained_glass_pane": "گﻧﺭ یﺍﻩﺯﻭﺮﻴﻓ ﻩﺮﺠﻨپ ﻪﺸﻴﺷ",
  "block.minecraft.purple_stained_glass_pane": "گﻧﺭ ﺶﻔﻨﺑ ﻩﺮﺠﻨپ ﻪﺸﻴﺷ",
  "block.minecraft.blue_stained_glass_pane": "گﻧﺭ یﺑﺁ ﻩﺮﺠﻨپ ﻪﺸﻴﺷ",
  "block.minecraft.brown_stained_glass_pane": "گﻧﺭ یﺍﻩﻮﻬﻗ ﻩﺮﺠﻨپ ﻪﺸﻴﺷ",
  "block.minecraft.green_stained_glass_pane": "گﻧﺭ ﺰﺒﺳ ﻩﺮﺠﻨپ ﻪﺸﻴﺷ",
  "block.minecraft.red_stained_glass_pane": "گﻧﺭ ﺰﻣﺮﻗ ﻩﺮﺠﻨپ ﻪﺸﻴﺷ",
  "block.minecraft.black_stained_glass_pane": "گﻧﺭ ﻩﺎﻴﺳ ﻩﺮﺠﻨپ ﻪﺸﻴﺷ",
  "block.minecraft.prismarine": "یﻳﺎﻳﺭﺩ ﺭﻮﺸﻨﻣ",
  "block.minecraft.prismarine_bricks": "یﻳﺎﻳﺭﺩ ﺭﻮﺸﻨﻣ یﺎﻫ ﺮﺟﺁ",
  "block.minecraft.dark_prismarine": "ﻩﺮﻴﺗ یﻳﺎﻳﺭﺩ ﺭﻮﺸﻨﻣ",
  "block.minecraft.prismarine_stairs": "یﻳﺎﻳﺭﺩ ﺭﻮﺸﻨﻣ ﻪﻠپ",
  "block.minecraft.prismarine_brick_stairs": "یﻳﺎﻳﺭﺩ ﺭﻮﺸﻨﻣ ﺮﺟﺁ ﻪﻠپ",
  "block.minecraft.dark_prismarine_stairs": "ﻩﺮﻴﺗ یﻳﺎﻳﺭﺩ ﺭﻮﺸﻨﻣ ﻪﻠپ",
  "block.minecraft.sea_lantern": "یﻳﺎﻳﺭﺩ ﺱﻮﻧﺎﻓ",
  "block.minecraft.red_sandstone": "ﺰﻣﺮﻗ گﻨﺳ ﻪﺳﺎﻣ",
  "block.minecraft.chiseled_red_sandstone": "ﻩﺩﺭﻮﺧ ﺵﺍﺮﺗ ﺰﻣﺮﻗ گﻨﺳ ﻪﺳﺎﻣ",
  "block.minecraft.cut_red_sandstone": "ﻩﺩﺭﻮﺧ ﺵﺮﺑ ﺰﻣﺮﻗ گﻨﺳ ﻪﺳﺎﻣ",
  "block.minecraft.red_sandstone_stairs": "ﺰﻣﺮﻗ گﻨﺳ ﻪﺳﺎﻣ ﻪﻠپ",
  "block.minecraft.repeating_command_block": "ﻩﺪﻨﻨک ﺭﺍﺮکﺗ ﻥﺎﻣﺮﻓ کﻼﺑ",
  "block.minecraft.chain_command_block": "یﺍ ﻩﺮیﺠﻧﺯ ﻥﺎﻣﺮﻓ کﻼﺑ",
  "block.minecraft.magma_block": "ﺎﻤگﺎﻣ کﻼﺑ",
  "block.minecraft.nether_wart_block": "ﺭﺪﻧ ﻞیگﺯ کﻮﻠﺑ",
  "block.minecraft.warped_wart_block": "ﻩﺩﺭﻮﺧچیپ ﻞیگﺯ کﻮﻠﺑ",
  "block.minecraft.red_nether_bricks": "ﺰﻣﺮﻗ یﺭﺪﻧ ﺮﺟﺁ",
  "block.minecraft.bone_block": "ﻥﺍﻮﺨﺘﺳﺍ کﻼﺑ",
  "block.minecraft.structure_void": "یﻟﺎﺧ ﺭﺎﺘﺧﺎﺳ",
  "block.minecraft.observer": "ﺮگﻩﺭﺎﻈﻧ",
  "block.minecraft.shulker_box": "ﺮکﻟﺎﺷ ﻪﺒﻌﺟ",
  "block.minecraft.white_shulker_box": "ﺮکﻟﺎﺷ ﺪﻴﻔﺳ ﻪﺒﻌﺟ",
  "block.minecraft.orange_shulker_box": "ﺮکﻟﺎﺷ یﺠﻧﺭﺎﻧ ﻪﺒﻌﺟ",
  "block.minecraft.magenta_shulker_box": "ﺮکﻟﺎﺷ یﻧﺍﻮﻏﺭﺍ ﻪﺒﻌﺟ",
  "block.minecraft.light_blue_shulker_box": "ﺮکﻟﺎﺷ ﻦﺷﻭﺭ یﺑﺁ ﻪﺒﻌﺟ",
  "block.minecraft.yellow_shulker_box": "ﺮکﻟﺎﺷ ﺩﺭﺯ ﻪﺒﻌﺟ",
  "block.minecraft.lime_shulker_box": "ﺮکﻟﺎﺷ ﻦﺷﻭﺭ ﺰﺒﺳ ﻪﺒﻌﺟ",
  "block.minecraft.pink_shulker_box": "ﺮکﻟﺎﺷ یﺗﺭﻮﺻ ﻪﺒﻌﺟ",
  "block.minecraft.gray_shulker_box": "ﺮکﻟﺎﺷ یﺮﺘﺴکﺎﺧ ﻪﺒﻌﺟ",
  "block.minecraft.light_gray_shulker_box": "ﺮکﻟﺎﺷ یﺍﻩﺮﻘﻧ ﻪﺒﻌﺟ",
  "block.minecraft.cyan_shulker_box": "ﺮکﻟﺎﺷ یﺍﻩﺯﻭﺮﻴﻓ ﻪﺒﻌﺟ",
  "block.minecraft.purple_shulker_box": "ﺮکﻟﺎﺷ ﺶﻔﻨﺑ ﻪﺒﻌﺟ",
  "block.minecraft.blue_shulker_box": "ﺮکﻟﺎﺷ یﺑﺁ ﻪﺒﻌﺟ",
  "block.minecraft.brown_shulker_box": "ﺮکﻟﺎﺷ یﺍﻩﻮﻬﻗ ﻪﺒﻌﺟ",
  "block.minecraft.green_shulker_box": "ﺮکﻟﺎﺷ ﺰﺒﺳ ﻪﺒﻌﺟ",
  "block.minecraft.red_shulker_box": "ﺮکﻟﺎﺷ ﺰﻣﺮﻗ ﻪﺒﻌﺟ",
  "block.minecraft.black_shulker_box": "ﺮکﻟﺎﺷ ﻩﺎﻴﺳ ﻪﺒﻌﺟ",
  "block.minecraft.white_glazed_terracotta": "ﺪﻴﻔﺳ ﻩﺪﺷ ﻩﺩﺍﺩ ﺏﺎﻌﻟ ﻝﺎﻔﺳ",
  "block.minecraft.orange_glazed_terracotta": "یﺠﻧﺭﺎﻧ ﻩﺪﺷ ﻩﺩﺍﺩ ﺏﺎﻌﻟ ﻝﺎﻔﺳ",
  "block.minecraft.magenta_glazed_terracotta": "یﻧﺍﻮﻏﺭﺍ ﻩﺪﺷ ﻩﺩﺍﺩ ﺏﺎﻌﻟ ﻝﺎﻔﺳ",
  "block.minecraft.light_blue_glazed_terracotta": "ﻦﺷﻭﺭ یﺑﺁ ﻩﺪﺷ ﻩﺩﺍﺩ ﺏﺎﻌﻟ ﻝﺎﻔﺳ",
  "block.minecraft.yellow_glazed_terracotta": "ﺩﺭﺯ ﻩﺪﺷ ﻩﺩﺍﺩ ﺏﺎﻌﻟ ﻝﺎﻔﺳ",
  "block.minecraft.lime_glazed_terracotta": "ﻦﺷﻭﺭ ﺰﺒﺳ ﻩﺪﺷ ﻩﺩﺍﺩ ﺏﺎﻌﻟ ﻝﺎﻔﺳ",
  "block.minecraft.pink_glazed_terracotta": "یﺗﺭﻮﺻ ﻩﺪﺷ ﻩﺩﺍﺩ ﺏﺎﻌﻟ ﻝﺎﻔﺳ",
  "block.minecraft.gray_glazed_terracotta": "یﺮﺘﺴکﺎﺧ ﻩﺪﺷ ﻩﺩﺍﺩ ﺏﺎﻌﻟ ﻝﺎﻔﺳ",
  "block.minecraft.light_gray_glazed_terracotta": "ﻦﺷﻭﺭ یﺮﺘﺴکﺎﺧ ﻩﺪﺷ ﻩﺩﺍﺩ ﺏﺎﻌﻟ ﻝﺎﻔﺳ",
  "block.minecraft.cyan_glazed_terracotta": "یﺍﻩﺯﻭﺮﻴﻓ ﻩﺪﺷ ﻩﺩﺍﺩ ﺏﺎﻌﻟ ﻝﺎﻔﺳ",
  "block.minecraft.purple_glazed_terracotta": "ﺶﻔﻨﺑ ﻩﺪﺷ ﻩﺩﺍﺩ ﺏﺎﻌﻟ ﻝﺎﻔﺳ",
  "block.minecraft.blue_glazed_terracotta": "یﺑﺁ ﻩﺪﺷ ﻩﺩﺍﺩ ﺏﺎﻌﻟ ﻝﺎﻔﺳ",
  "block.minecraft.brown_glazed_terracotta": "یﺍﻩﻮﻬﻗ ﻩﺪﺷ ﺏﺎﻌﻟ ﻝﺎﻔﺳ",
  "block.minecraft.green_glazed_terracotta": "ﺰﺒﺳ ﻩﺪﺷ ﻩﺩﺍﺩ ﺏﺎﻌﻟ ﻝﺎﻔﺳ",
  "block.minecraft.red_glazed_terracotta": "ﺰﻣﺮﻗ ﻩﺪﺷ ﻩﺩﺍﺩ ﺏﺎﻌﻟ ﻝﺎﻔﺳ",
  "block.minecraft.black_glazed_terracotta": "ﻩﺎﻴﺳ ﻩﺪﺷ ﻩﺩﺍﺩ ﺏﺎﻌﻟ ﻝﺎﻔﺳ",
  "block.minecraft.white_concrete": "ﺪﻴﻔﺳ ﻦﺘﺑ",
  "block.minecraft.orange_concrete": "یﺠﻧﺭﺎﻧ ﻦﺘﺑ",
  "block.minecraft.magenta_concrete": "یﻧﺍﻮﻏﺭﺍ ﻦﺘﺑ",
  "block.minecraft.light_blue_concrete": "ﻦﺷﻭﺭ یﺑﺁ ﻦﺘﺑ",
  "block.minecraft.yellow_concrete": "ﺩﺭﺯ ﻦﺘﺑ",
  "block.minecraft.lime_concrete": "ﻦﺷﻭﺭ ﺰﺒﺳ ﻦﺘﺑ",
  "block.minecraft.pink_concrete": "یﺗﺭﻮﺻ ﻦﺘﺑ",
  "block.minecraft.gray_concrete": "یﺮﺘﺴکﺎﺧ ﻦﺘﺑ",
  "block.minecraft.light_gray_concrete": "ﻦﺷﻭﺭ یﺮﺘﺴکﺎﺧ ﻦﺘﺑ",
  "block.minecraft.cyan_concrete": "یﺍﻩﺯﻭﺮﻴﻓ ﻦﺘﺑ",
  "block.minecraft.purple_concrete": "ﺶﻔﻨﺑ ﻦﺘﺑ",
  "block.minecraft.blue_concrete": "یﺑﺁ ﻦﺘﺑ",
  "block.minecraft.brown_concrete": "یﺍﻩﻮﻬﻗ ﻦﺘﺑ",
  "block.minecraft.green_concrete": "ﺰﺒﺳ ﻦﺘﺑ",
  "block.minecraft.red_concrete": "ﺰﻣﺮﻗ ﻦﺘﺑ",
  "block.minecraft.black_concrete": "ﻩﺎﻴﺳ ﻦﺘﺑ",
  "block.minecraft.white_concrete_powder": "ﺪﻴﻔﺳ ﻦﺘﺑ ﺭﺩﻮپ",
  "block.minecraft.orange_concrete_powder": "یﺠﻧﺭﺎﻧ ﻦﺘﺑ ﺭﺩﻮپ",
  "block.minecraft.magenta_concrete_powder": "یﻧﺍﻮﻏﺭﺍ ﻦﺘﺑ ﺭﺩﻮپ",
  "block.minecraft.light_blue_concrete_powder": "ﻦﺷﻭﺭ یﺑﺁ ﻦﺘﺑ ﺭﺩﻮپ",
  "block.minecraft.yellow_concrete_powder": "ﺩﺭﺯ ﻦﺘﺑ ﺭﺩﻮپ",
  "block.minecraft.lime_concrete_powder": "ﻦﺷﻭﺭ ﺰﺒﺳ ﻦﺘﺑ ﺭﺩﻮپ",
  "block.minecraft.pink_concrete_powder": "یﺗﺭﻮﺻ ﻦﺘﺑ ﺭﺩﻮپ",
  "block.minecraft.gray_concrete_powder": "یﺮﺘﺴکﺎﺧ ﻦﺘﺑ ﺭﺩﻮپ",
  "block.minecraft.light_gray_concrete_powder": "ﻦﺷﻭﺭ یﺮﺘﺴکﺎﺧ ﻦﺘﺑ ﺭﺩﻮپ",
  "block.minecraft.cyan_concrete_powder": "یﺍﻩﺯﻭﺮﻴﻓ ﻦﺘﺑ ﺭﺩﻮپ",
  "block.minecraft.purple_concrete_powder": "ﺶﻔﻨﺑ ﻦﺘﺑ ﺭﺩﻮپ",
  "block.minecraft.blue_concrete_powder": "یﺑﺁ ﻦﺘﺑ ﺭﺩﻮپ",
  "block.minecraft.brown_concrete_powder": "یﺍﻩﻮﻬﻗ ﻦﺘﺑ ﺭﺩﻮپ",
  "block.minecraft.green_concrete_powder": "ﺰﺒﺳ ﻦﺘﺑ ﺭﺩﻮپ",
  "block.minecraft.red_concrete_powder": "ﺰﻣﺮﻗ ﻦﺘﺑ ﺭﺩﻮپ",
  "block.minecraft.black_concrete_powder": "ﻩﺎﻴﺳ ﻦﺘﺑ ﺭﺩﻮپ",
  "block.minecraft.turtle_egg": "ﺖﺸپ کﻻ ﻢﺨﺗ",
  "block.minecraft.dead_tube_coral_block": "ﻩﺩﺮﻣ یﺍﻪﻟﻮﻟ ﻥﺎﺟﺮﻣ کﻮﻠﺑ",
  "block.minecraft.dead_brain_coral_block": "ﻩﺩﺮﻣ یﺰﻐﻣ ﻥﺎﺟﺮﻣ کﻮﻠﺑ",
  "block.minecraft.dead_bubble_coral_block": "ﻩﺩﺮﻣ یﺑﺎﺒﺣ ﻥﺎﺟﺮﻣ کﻮﻠﺑ",
  "block.minecraft.dead_fire_coral_block": "ﻩﺩﺮﻣ ﻦیﺸﺗﺁ ﻥﺎﺟﺮﻣ کﻮﻠﺑ",
  "block.minecraft.dead_horn_coral_block": "ﻩﺩﺮﻣ یکﺧﺎﺷ ﻥﺎﺟﺮﻣ کﻮﻠﺑ",
  "block.minecraft.tube_coral_block": "یﺍﻪﻟﻮﻟ ﻥﺎﺟﺮﻣ کﻮﻠﺑ",
  "block.minecraft.brain_coral_block": "یﺰﻐﻣ ﻥﺎﺟﺮﻣ کﻮﻠﺑ",
  "block.minecraft.bubble_coral_block": "یﺑﺎﺒﺣ ﻥﺎﺟﺮﻣ کﻮﻠﺑ",
  "block.minecraft.fire_coral_block": "ﻦیﺸﺗﺁ ﻥﺎﺟﺮﻣ کﻮﻠﺑ",
  "block.minecraft.horn_coral_block": "یکﺧﺎﺷ ﻥﺎﺟﺮﻣ کﻮﻠﺑ",
  "block.minecraft.tube_coral": "یﺍﻪﻟﻮﻟ ﻥﺎﺟﺮﻣ",
  "block.minecraft.brain_coral": "یﺰﻐﻣ ﻥﺎﺟﺮﻣ",
  "block.minecraft.bubble_coral": "یﺑﺎﺒﺣ ﻥﺎﺟﺮﻣ",
  "block.minecraft.fire_coral": "ﻦیﺸﺗﺁ ﻥﺎﺟﺮﻣ",
  "block.minecraft.horn_coral": "یکﺧﺎﺷ ﻥﺎﺟﺮﻣ",
  "block.minecraft.dead_brain_coral": "ﻩﺩﺮﻣ یﺰﻐﻣ ﻥﺎﺟﺮﻣ",
  "block.minecraft.dead_bubble_coral": "ﻩﺩﺮﻣ یﻧﺎﺟﺮﻣ ﺏﺎﺒﺣ",
  "block.minecraft.dead_fire_coral": "ﻩﺩﺮﻣ ﻦیﺸﺗﺁ ﻥﺎﺟﺮﻣ",
  "block.minecraft.dead_horn_coral": "ﻩﺩﺮﻣ یﺧﺎﺷ ﻥﺎﺟﺮﻣ",
  "block.minecraft.dead_tube_coral": "ﻩﺩﺮﻣ یﺍﻪﻟﻮﻟ ﻥﺎﺟﺮﻣ",
  "block.minecraft.tube_coral_fan": "یﻧﺎﺟﺮﻣ ﻥﺰﺑﺩﺎﺑ ی ﻪﻟﻮﻟ",
  "block.minecraft.brain_coral_fan": "یﻧﺎﺟﺮﻣ ﻥﺰﺑﺩﺎﺑ ﺰﻐﻣ",
  "block.minecraft.bubble_coral_fan": "یﻧﺎﺟﺮﻣ ﻥﺰﺑﺩﺎﺑ ﺏﺎﺒﺣ",
  "block.minecraft.fire_coral_fan": "ﻦیﺸﺗﺁ ﻥﺎﺟﺮﻣ",
  "block.minecraft.horn_coral_fan": "ﺭﺍﺪﺧﺎﺷ ﻥﺎﺟﺮﻣ",
  "block.minecraft.dead_tube_coral_fan": "ﻩﺩﺮﻣ یﺍ ﻪﻟﻮﻟ ﻥﺎﺟﺮﻣ",
  "block.minecraft.dead_brain_coral_fan": "ﻩﺩﺮﻣ یﺰﻐﻣ ﻥﺎﺟﺮﻣ",
  "block.minecraft.dead_bubble_coral_fan": "ﻩﺩﺮﻣ یﺑﺎﺒﺣ ﻥﺎﺟﺮﻣ",
  "block.minecraft.dead_fire_coral_fan": "ﻩﺩﺮﻣ ﻦیﺸﺗﺁ ﻥﺎﺟﺮﻣ",
  "block.minecraft.dead_horn_coral_fan": "ﻩﺩﺮﻣ یکﺧﺎﺷ ﻥﺎﺟﺮﻣ",
  "block.minecraft.blue_ice": "یﺑﺁ ﺦی",
  "block.minecraft.conduit": "ﺯﺍﺪﻧﺍ ﻥﺎیﺮﺟ",
  "block.minecraft.polished_granite_stairs": "یﻠﻘﻴﺻ یﺘیﻧﺍﺮگ ﻪﻠپ",
  "block.minecraft.smooth_red_sandstone_stairs": "ﻑﺎﺻ ﺰﻣﺮﻗ گﻨﺳ ﻪﺳﺎﻣ ﻪﻠپ",
  "block.minecraft.mossy_stone_brick_stairs": "ﻪﺘﻓﺮگ ﻩﺰﺧ یگﻨﺳ ﺮﺟﺁ ﻪﻠپ",
  "block.minecraft.polished_diorite_stairs": "ﻩﺩﺭﻮﺧ ﺵﺍﺮﺗ یﺘیﺭﻮیﺩ ﻪﻠپ",
  "block.minecraft.mossy_cobblestone_stairs": "یﺍ ﻩﺰﺧ گﻨﺳ ﻩﻮﻠﻗ ﻪﻠپ",
  "block.minecraft.end_stone_brick_stairs": "ﺪﻧﺍ گﻨﺳ ﺮﺟﺁ ﻪﻠپ",
  "block.minecraft.stone_stairs": "یگﻨﺳ ﻪﻠپ",
  "block.minecraft.smooth_sandstone_stairs": "ﻑﺎﺻ گﻨﺳ ﻪﺳﺎﻣ ﻪﻠپ",
  "block.minecraft.smooth_quartz_stairs": "یﻠﻘﻴﺻ یﻨیچ گﻨﺳ ﻪﻠپ",
  "block.minecraft.granite_stairs": "یﺘیﻧﺍﺮگ ﻪﻠپ",
  "block.minecraft.andesite_stairs": "ﺖیﺯﺪﻧﺁ ﻪﻠپ",
  "block.minecraft.red_nether_brick_stairs": "ﺰﻣﺮﻗ یﺭﺪﻧ ﺮﺟﺁ ﻪﻠپ",
  "block.minecraft.polished_andesite_stairs": "ﻩﺩﺭﻮﺧ ﺵﺍﺮﺗ ﺖیﺯﺪﻧﺁ ﻪﻠپ",
  "block.minecraft.diorite_stairs": "ﺖﻳﺭﻮﻳﺩ ﻪﻠپ",
  "block.minecraft.polished_granite_slab": "ﻩﺩﺭﻮﺧ ﺵﺍﺮﺗ یﺘیﻧﺍﺮگ ﻪﻠپ",
  "block.minecraft.smooth_red_sandstone_slab": "ﻑﺎﺻ ﺰﻣﺮﻗ گﻨﺳ ﻪﺳﺎﻣ ﻪﻤﻴﻧ",
  "block.minecraft.mossy_stone_brick_slab": "ﻒﺼﻧ ﻪﺘﻓﺮگ ﻩﺰﺧ یگﻨﺳ ﺮﺟﺁ",
  "block.minecraft.polished_diorite_slab": "ﻩﺩﺭﻮﺧ ﺵﺍﺮﺗ ﺖیﺭﻮیﺩ ﻪﻤﻴﻧ",
  "block.minecraft.mossy_cobblestone_slab": "ﻒﺼﻧ ﻪﺘﻓﺮگ ﻩﺰﺧ گﻨﺳ ﻩﻮﻠﻗ",
  "block.minecraft.end_stone_brick_slab": "ﻒﺼﻧ ﺪﻧﺍ گﻨﺳ ﺮﺟﺁ",
  "block.minecraft.smooth_sandstone_slab": "ﻑﺎﺻ گﻨﺳ ﻪﺳﺎﻣ ﻪﻤﻴﻧ",
  "block.minecraft.smooth_quartz_slab": "ﻒﺼﻧ یﻠﻘﻴﺻ یﻨیچ گﻨﺳ",
  "block.minecraft.granite_slab": "ﺖیﻧﺍﺮگ ﻪﻤﻴﻧ",
  "block.minecraft.andesite_slab": "ﺖیﺯﺪﻧﺁ ﻪﻤﻴﻧ",
  "block.minecraft.red_nether_brick_slab": "ﺰﻣﺮﻗ یﺭﺪﻧ ﺮﺟﺁ ﻪﻤﻴﻧ",
  "block.minecraft.polished_andesite_slab": "ﻩﺩﺭﻮﺧ ﺵﺍﺮﺗ ﺖیﺯﺪﻧﺁ ﻪﻤﻴﻧ",
  "block.minecraft.diorite_slab": "ﺖیﺭﻮیﺩ ﻪﻤﻴﻧ",
  "block.minecraft.scaffolding": "ﺖﺴﺑﺭﺍﺩ",
  "block.minecraft.iron_door": "یﻨﻫﺁ ﺏﺭﺩ",
  "block.minecraft.oak_door": "ﻁﻮﻠﺑ ﺏﺭﺩ",
  "block.minecraft.spruce_door": "ﺝﺎک ﺏﺭﺩ",
  "block.minecraft.birch_door": "ﺱﻮﺗ ﺏﺭﺩ",
  "block.minecraft.jungle_door": "یﻠگﻨﺟ ﺏﺭﺩ",
  "block.minecraft.acacia_door": "ﺎﻴﻗﺎﻗﺍ ﺏﺭﺩ",
  "block.minecraft.dark_oak_door": "ﻩﺮﻴﺗ ﻁﻮﻠﺑ ﺏﺭﺩ",
  "block.minecraft.crimson_door": "ﻥﻮﺴﻤﻳﺮک ﺏﺭﺩ",
  "block.minecraft.warped_door": "ﻩﺩﺭﻮﺧچیپ ﺏﺭﺩ",
  "block.minecraft.repeater": "ﻲﻧﻮﺘﺳﺩﺭ ﻩﺪﻨﻨکﺭﺍﺮکﺗ",
  "block.minecraft.comparator": "ﻲﻧﻮﺘﺳﺩﺭ ﺮگ ﻪﺴیﺎﻘﻣ",
  "block.minecraft.structure_block": "کﻮﻠﺑ ﺭﺎﺘﺧﺎﺳ",
  "block.minecraft.jigsaw": "یﺭﺎک ﺖﺒﻨﻣ کﻼﺑ",
  "item.minecraft.turtle_helmet": "ﺖﺸپکﻻ کﻻ□□:ﺖﺳﺍ ﺮﺳ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ2+",
  "item.minecraft.scute": "ﻪچﺮپﺳ",
  "item.minecraft.iron_shovel": "یﻨﻫﺁ ﻞﻴﺑ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ3.5+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 3-",
  "item.minecraft.iron_pickaxe": "ﻲﻨﻫﺁ گﻨﻠک□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ3+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 2.8-",
  "item.minecraft.iron_axe": "ﻲﻨﻫﺁ ﺮﺒﺗ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ8+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 3.1-",
  "item.minecraft.flint_and_steel": "ﻪﻧﺯ ﺶﺗﺁ",
  "item.minecraft.apple": "ﺐﻴﺳ",
  "item.minecraft.bow": "ﻥﺎﻤک",
  "item.minecraft.arrow": "ﺮﻴﺗ",
  "item.minecraft.coal": "گﻨﺳ ﻝﺎﻏﺫ",
  "item.minecraft.charcoal": "ﺏﻮچ ﻝﺎﻏﺫ",
  "item.minecraft.diamond": "ﺱﺎﻤﻟﺍ",
  "item.minecraft.iron_ingot": "ﻦﻫﺁ ﺶﻤﺷ",
  "item.minecraft.gold_ingot": "ﻼﻃ ﺶﻤﺷ",
  "item.minecraft.netherite_ingot": "ﺖﻳﺍﺭﺪﻧ ﺶﻤﺷ",
  "item.minecraft.netherite_scrap": "ﺖﻳﺍﺭﺪﻧ ﻪکﺗ",
  "item.minecraft.iron_sword": "ﻲﻨﻫﺁ ﺮﻴﺸﻤﺷ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ5+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 2.4-",
  "item.minecraft.wooden_sword": "ﻲﺑﻮچ ﺮﻴﺸﻤﺷ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ3+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 2.4-",
  "item.minecraft.wooden_shovel": "یﺑﻮچ ﻞﻴﺑ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ1.5+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 3-",
  "item.minecraft.wooden_pickaxe": "ﻲﺑﻮچ گﻨﻠک□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ1+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 2.8-",
  "item.minecraft.wooden_axe": "ﻲﺑﻮچ ﺮﺒﺗ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ6+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 3.2-",
  "item.minecraft.stone_sword": "ﻲگﻨﺳ ﺮﻴﺸﻤﺷ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ4+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 2.4-",
  "item.minecraft.stone_shovel": "یگﻨﺳ ﻞﻴﺑ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ2.5+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 3-",
  "item.minecraft.stone_pickaxe": "ﻲگﻨﺳ گﻨﻠک□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ2+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 2.8-",
  "item.minecraft.stone_axe": "ﻲگﻨﺳ ﺮﺒﺗ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ8+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 3.2-",
  "item.minecraft.diamond_sword": "یﺳﺎﻤﻟﺍ ﺮﻴﺸﻤﺷ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ6+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 2.4-",
  "item.minecraft.diamond_shovel": "یﺳﺎﻤﻟﺍ ﻞﻴﺑ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ4.5+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 3-",
  "item.minecraft.diamond_pickaxe": "یﺳﺎﻤﻟﺍ گﻨﻠک□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ4+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 2.8-",
  "item.minecraft.diamond_axe": "یﺳﺎﻤﻟﺍ ﺮﺒﺗ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ8+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 3-",
  "item.minecraft.stick": "ﻲﺑﻮچ ﻪکیﺗ",
  "item.minecraft.bowl": "ﻪﺳﺎک",
  "item.minecraft.mushroom_stew": "چﺭﺎﻗ پﻮﺳ",
  "item.minecraft.golden_sword": "ﻲﻳﻼﻃ ﺮﻴﺸﻤﺷ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ3+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 2.4-",
  "item.minecraft.golden_shovel": "یﻳﻼﻃ ﻞﻴﺑ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ1.5+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 3-",
  "item.minecraft.golden_pickaxe": "ﻲﻳﻼﻃ گﻨﻠک□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ1+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 2.8-",
  "item.minecraft.golden_axe": "ﻲﻳﻼﻃ ﺮﺒﺗ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ6+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 3-",
  "item.minecraft.netherite_sword": "ﺖﻳﺍﺭﺪﻧ ﺮیﺸﻤﺷ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ7+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 2.4-",
  "item.minecraft.netherite_shovel": "ﺖﻳﺍﺭﺪﻧ ﻞیﺑ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ5.5+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 3-",
  "item.minecraft.netherite_pickaxe": "ﺖﻳﺍﺭﺪﻧ گﻨﻠک□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ5+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 2.8-",
  "item.minecraft.netherite_axe": "ﺖﻳﺍﺭﺪﻧ ﺮﺒﺗ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ9+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 3-",
  "item.minecraft.string": "ﻪﺘﺷﺭ",
  "item.minecraft.feather": "ﺮپ",
  "item.minecraft.gunpowder": "ﺕﻭﺭﺎﺑ",
  "item.minecraft.wooden_hoe": "یﺑﻮچ ﺶﻴﺧ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 3-",
  "item.minecraft.stone_hoe": "یگﻨﺳ ﺶﻴﺧ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 2-",
  "item.minecraft.iron_hoe": "یﻨﻫﺁ ﺶﻴﺧ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 1-",
  "item.minecraft.diamond_hoe": "یﺳﺎﻤﻟﺍ ﺶﻴﺧ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ",
  "item.minecraft.golden_hoe": "یﻳﻼﻃ ﺶﻴﺧ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 3-",
  "item.minecraft.netherite_hoe": "ﺖﻳﺍﺭﺪﻧ ﺶیﺧ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ",
  "item.minecraft.wheat_seeds": "ﻡﺪﻨگ یﺎﻫ ﻪﻧﺍﺩ",
  "item.minecraft.wheat": "ﻡﺪﻨگ",
  "item.minecraft.bread": "ﻥﺎﻧ",
  "item.minecraft.leather_helmet": "ﻡﺮچ ﻩﻼک□□:ﺖﺳﺍ ﺮﺳ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ1+",
  "item.minecraft.leather_chestplate": "ﻡﺮچ ﻦﻫﺍﺮﻴپ□□:ﺖﺳﺍ ﻥﺪﺑ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ3+",
  "item.minecraft.leather_leggings": "ﻡﺮچ ﺭﺍﻮﻠﺷ□□:ﺖﺳﺍ ﺎپ ﻕﺎﺳ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ2+",
  "item.minecraft.leather_boots": "یﻣﺮچ ی ﻪﻤکچ□□:ﺖﺳﺎپ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ1+",
  "item.minecraft.chainmail_helmet": "یﺮیﺠﻧﺯ ﺩﻮﺨﻫﻼک□□:ﺖﺳﺍ ﺮﺳ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ2+",
  "item.minecraft.chainmail_chestplate": "یﺮﻴﺠﻧﺯ ﻦﻫﺍﺮﻴپ□□:ﺖﺳﺍ ﻥﺪﺑ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ5+",
  "item.minecraft.chainmail_leggings": "یﺮﻴﺠﻧﺯ ﺭﺍﻮﻠﺷ□□:ﺖﺳﺍ ﺎپ ﻕﺎﺳ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ4+",
  "item.minecraft.chainmail_boots": "یﺮیﺠﻧﺯ ﺶﻔک□□:ﺖﺳﺎپ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ1+",
  "item.minecraft.iron_helmet": "ﻲﻨﻫﺁ ﻩﻼک□□:ﺖﺳﺍ ﺮﺳ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ2+",
  "item.minecraft.iron_chestplate": "ﻲﻨﻫﺁ ﻦﻫﺍﺮﻴپ□□:ﺖﺳﺍ ﻥﺪﺑ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ6+",
  "item.minecraft.iron_leggings": "ﻲﻨﻫﺁ ﺭﺍﻮﻠﺷ□□:ﺖﺳﺍ ﺎپ ﻕﺎﺳ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ5+",
  "item.minecraft.iron_boots": "ﻲﻨﻫﺁ ﺶﻔک□□:ﺖﺳﺎپ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ2+",
  "item.minecraft.diamond_helmet": "ﺱﺎﻤﻟﺍ ﺩﻮﺨﻫﻼک□□:ﺖﺳﺍ ﺮﺳ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ3+□ﻩﺭﺯ یﺘﺨﺳ2+",
  "item.minecraft.diamond_chestplate": "ﺱﺎﻤﻟﺍ ﻦﻫﺍﺮﻴپ□□:ﺖﺳﺍ ﻥﺪﺑ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ8+□ﻩﺭﺯ یﺘﺨﺳ2+",
  "item.minecraft.diamond_leggings": "ﺱﺎﻤﻟﺍ ﺭﺍﻮﻠﺷ□□:ﺖﺳﺍ ﺎپ ﻕﺎﺳ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ6+□ﻩﺭﺯ یﺘﺨﺳ2+",
  "item.minecraft.diamond_boots": "ﺱﺎﻤﻟﺍ ﺶﻔک□□:ﺖﺳﺎپ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ3+□ﻩﺭﺯ یﺘﺨﺳ2+",
  "item.minecraft.golden_helmet": "ﻲﻳﻼﻃ ﺩﻮﺨﻫﻼک□□:ﺖﺳﺍ ﺮﺳ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ2+",
  "item.minecraft.golden_chestplate": "ﻲﻳﻼﻃ ﻦﻫﺍﺮﻴپ□□:ﺖﺳﺍ ﻥﺪﺑ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ5+",
  "item.minecraft.golden_leggings": "ﻲﻳﻼﻃ ﺭﺍﻮﻠﺷ□□:ﺖﺳﺍ ﺎپ ﻕﺎﺳ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ3+",
  "item.minecraft.golden_boots": "ﻲﻳﻼﻃ ﺶﻔک□□:ﺖﺳﺎپ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ1+",
  "item.minecraft.netherite_helmet": "ﺖﻳﺍﺭﺪﻧ ﺩﻮﺧﻩﻼک□□:ﺖﺳﺍ ﺮﺳ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ3+□ﻩﺭﺯ یﺘﺨﺳ3+□\"ﺏﺎﺗﺮپ\" ﺮﺑﺍﺮﺑ ﺭﺩ ﺖﻣﻭﺎﻘﻣ1+",
  "item.minecraft.netherite_chestplate": "ﺖﻳﺍﺭﺪﻧ ﻩﺭﺯ□□:ﺖﺳﺍ ﻥﺪﺑ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ8+□ﻩﺭﺯ یﺘﺨﺳ3+□\"ﺏﺎﺗﺮپ\" ﺮﺑﺍﺮﺑ ﺭﺩ ﺖﻣﻭﺎﻘﻣ1+",
  "item.minecraft.netherite_leggings": "ﺖﻳﺍﺭﺪﻧ ﺭﺍﻮﻠﺷ□□:ﺖﺳﺍ ﺎپ ﻕﺎﺳ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ6+□ﻩﺭﺯ یﺘﺨﺳ3+□\"ﺏﺎﺗﺮپ\" ﺮﺑﺍﺮﺑ ﺭﺩ ﺖﻣﻭﺎﻘﻣ1+",
  "item.minecraft.netherite_boots": "ﺖﻳﺍﺭﺪﻧ یﻪﻤکچ□□:ﺖﺳﺎپ یﻭﺭ ﻪک یﻣﺎگﻨﻫ□ﻩﺭﺯ3+□ﻩﺭﺯ یﺘﺨﺳ3+□\"ﺏﺎﺗﺮپ\" ﺮﺑﺍﺮﺑ ﺭﺩ ﺖﻣﻭﺎﻘﻣ1+",
  "item.minecraft.flint": "ﻕﺎﻤﺨچ گﻨﺳ",
  "item.minecraft.porkchop": "ﻡﺎﺧ کﻮﺧ ﺖﺷﻮگ",
  "item.minecraft.cooked_porkchop": "کﻮﺧ ﻪﺘﺨپ ﺖﺷﻮگ",
  "item.minecraft.painting": "یﺷﺎﻘﻧ ﻮﻠﺑﺎﺗ",
  "item.minecraft.golden_apple": "یﻳﻼﻃ ﺐﻴﺳ",
  "item.minecraft.enchanted_golden_apple": "یﻳﻭﺩﺎﺟ یﻳﻼﻃ ﺐﻴﺳ",
  "block.minecraft.oak_sign": "ﻁﻮﻠﺑ ﺏﻮچ ﻮﻠﺑﺎﺗ",
  "block.minecraft.spruce_sign": "ﺝﺎک ﺏﻮچ ﻮﻠﺑﺎﺗ",
  "block.minecraft.birch_sign": "ﺱﻮﺗ ﻮﻠﺑﺎﺗ",
  "block.minecraft.jungle_sign": "یﻠگﻨﺟ ﺏﻮچ ﻮﻠﺑﺎﺗ",
  "block.minecraft.acacia_sign": "ﺎﻴﻗﺎﻗﺍ ﺏﻮچ ﻮﻠﺑﺎﺗ",
  "block.minecraft.dark_oak_sign": "ﻩﺎﻴﺳ ﻁﻮﻠﺑ ﺏﻮچ ﻮﻠﺑﺎﺗ",
  "block.minecraft.crimson_sign": "ﻥﻮﺴﻤﻳﺮک یﻮﻠﺑﺎﺗ",
  "block.minecraft.warped_sign": "ﻩﺩﺭﻮﺧچیپ یﻮﻠﺑﺎﺗ",
  "item.minecraft.bucket": "ﻞﻄﺳ",
  "item.minecraft.water_bucket": "ﺏﺁ ﻞﻄﺳ",
  "item.minecraft.lava_bucket": "ﻩﺯﺍﺪگ ﻞﻄﺳ",
  "item.minecraft.minecart": "ﻥﺪﻌﻣ ﻦﻴﺷﺎﻣ",
  "item.minecraft.saddle": "ﻦﻳﺯ",
  "item.minecraft.redstone": "ﻥﻮﺘﺳﺩﺭ ﺩﺮﹷگ",
  "item.minecraft.snowball": "ﻲﻓﺮﺑ ﻪﻟﻮگ",
  "item.minecraft.oak_boat": "ﻁﻮﻠﺑ ﻖﻳﺎﻗ",
  "item.minecraft.leather": "ﻡﺮچ",
  "item.minecraft.milk_bucket": "ﺮﻴﺷ ﻞﻄﺳ",
  "item.minecraft.pufferfish_bucket": "یکﻨکﺩﺎﺑ یﻫﺎﻣ ﻞﻄﺳ",
  "item.minecraft.salmon_bucket": "ﻥﻮﻤﻟﺎﺳ یﻫﺎﻣ ﻞﻄﺳ",
  "item.minecraft.cod_bucket": "یﻫﺎﻣﻦﻏﻭﺭ ﻞﻄﺳ",
  "item.minecraft.tropical_fish_bucket": "ییﺍﻮﺘﺳﺍ یﻫﺎﻣ ﻞﻄﺳ",
  "item.minecraft.brick": "ﺮﺟﺁ",
  "item.minecraft.clay_ball": "ﻝﺎﻔﺳ ﻩﺩﻮﺗ",
  "block.minecraft.dried_kelp_block": "ﻩﺪﺷ کﺸﺧ یﻳﺎﻳﺭﺩ کﺒﻠﺟ کﻮﻠﺑ",
  "item.minecraft.paper": "ﺬﻏﺎک",
  "item.minecraft.book": "ﺏﺎﺘک",
  "item.minecraft.slime_ball": "ﻦﺠﻟ پﻮﺗ",
  "item.minecraft.chest_minecart": "ﻪچﻗﻭﺪﻨﺻ ﺎﺑ ﻥﺪﻌﻣ ﻦﻴﺷﺎﻣ",
  "item.minecraft.furnace_minecart": "ﻩﺭﻮک ﺎﺑ ﻥﺪﻌﻣ ﻦﻴﺷﺎﻣ",
  "item.minecraft.egg": "ﻍﺮﻣ ﻢﺨﺗ",
  "item.minecraft.compass": "ﺎﻤﻧ ﺐﻄﻗ",
  "item.minecraft.fishing_rod": "ﻱﺮﻴگﻴﻫﺎﻣ ﺏﻮچ",
  "item.minecraft.clock": "ﺖﻋﺎﺳ",
  "item.minecraft.glowstone_dust": "ﺎﻨﺷﻭﺭ ﺩﺮگ",
  "item.minecraft.cod": "ﻡﺎﺧ یﻫﺎﻣﻦﻏﻭﺭ",
  "item.minecraft.salmon": "ﻡﺎﺧ ﻥﻮﻤﻟﺎﺳ یﻫﺎﻣ",
  "item.minecraft.tropical_fish": "ییﺍﻮﺘﺳﺍ یﻫﺎﻣ",
  "item.minecraft.pufferfish": "یکﻨکﺩﺎﺑ یﻫﺎﻣ",
  "item.minecraft.cooked_cod": "ﻩﺪﺷ ﻪﺘﺨپ یﻫﺎﻣﻦﻏﻭﺭ",
  "item.minecraft.cooked_salmon": "ﻪﺘﺨپ ﻥﻮﻤﻟﺎﺳ یﻫﺎﻣ",
  "item.minecraft.ink_sac": "ﺐکﺮﻣ",
  "item.minecraft.red_dye": "ﺰﻣﺮﻗ گﻧﺭ",
  "item.minecraft.green_dye": "ﺰﺒﺳ گﻧﺭ",
  "item.minecraft.cocoa_beans": "ﻮﺋﺎکﺎک ﻪﻧﺍﺩ",
  "item.minecraft.lapis_lazuli": "ﺩﺭﻮﺟﻻ",
  "item.minecraft.purple_dye": "ﺶﻔﻨﺑ گﻧﺭ",
  "item.minecraft.cyan_dye": "یﺍﻩﺯﻭﺮﻴﻓ گﻧﺭ",
  "item.minecraft.light_gray_dye": "یﺍﻩﺮﻘﻧ گﻧﺭ",
  "item.minecraft.gray_dye": "یﺮﺘﺴکﺎﺧ گﻧﺭ",
  "item.minecraft.pink_dye": "یﺗﺭﻮﺻ گﻧﺭ",
  "item.minecraft.lime_dye": "ﻦﺷﻭﺭ ﺰﺒﺳ گﻧﺭ",
  "item.minecraft.yellow_dye": "ﺩﺭﺯ گﻧﺭ",
  "item.minecraft.light_blue_dye": "یﻧﺎﻤﺳﺁ یﺑﺁ گﻧﺭ",
  "item.minecraft.magenta_dye": "یﺑﺎﺧﺮﺳ گﻧﺭ",
  "item.minecraft.orange_dye": "یﺠﻧﺭﺎﻧ گﻧﺭ",
  "item.minecraft.bone_meal": "ﺮگﺭﻭﺭﺎﺑ",
  "item.minecraft.blue_dye": "یﺑﺁ گﻧﺭ",
  "item.minecraft.brown_dye": "یﺍﻩﻮﻬﻗ گﻧﺭ",
  "item.minecraft.black_dye": "ﻩﺎﻴﺳ گﻧﺭ",
  "item.minecraft.white_dye": "ﺪﻴﻔﺳ گﻧﺭ",
  "item.minecraft.bone": "ﻥﺍﻮﺨﺘﺳﺍ",
  "item.minecraft.sugar": "ﺮکﺷ",
  "block.minecraft.cake": "کﻴک",
  "block.minecraft.white_bed": "ﺪﻴﻔﺳ ﺖﺨﺗ",
  "block.minecraft.orange_bed": "یﺠﻧﺭﺎﻧ ﺖﺨﺗ",
  "block.minecraft.magenta_bed": "یﻧﺍﻮﻏﺭﺍ ﺖﺨﺗ",
  "block.minecraft.light_blue_bed": "ﻦﺷﻭﺭ یﺑﺁ ﺖﺨﺗ",
  "block.minecraft.yellow_bed": "ﺩﺭﺯ ﺖﺨﺗ",
  "block.minecraft.lime_bed": "ﻦﺷﻭﺭ ﺰﺒﺳ ﺖﺨﺗ",
  "block.minecraft.pink_bed": "یﺗﺭﻮﺻ ﺖﺨﺗ",
  "block.minecraft.gray_bed": "یﺮﺘﺴکﺎﺧ ﺖﺨﺗ",
  "block.minecraft.light_gray_bed": "ﻦﺷﻭﺭ یﺮﺘﺴکﺎﺧ ﺖﺨﺗ",
  "block.minecraft.cyan_bed": "یﺍﻩﺯﻭﺮﻴﻓ ﺖﺨﺗ",
  "block.minecraft.purple_bed": "ﺶﻔﻨﺑ ﺖﺨﺗ",
  "block.minecraft.blue_bed": "یﺑﺁ ﺖﺨﺗ",
  "block.minecraft.brown_bed": "یﺍﻩﻮﻬﻗ ﺖﺨﺗ",
  "block.minecraft.green_bed": "ﺰﺒﺳ ﺖﺨﺗ",
  "block.minecraft.red_bed": "ﺰﻣﺮﻗ ﺖﺨﺗ",
  "block.minecraft.black_bed": "ﻩﺎﻴﺳ ﺖﺨﺗ",
  "item.minecraft.cookie": "ﺖﻴﻳﻮکﺴﻴﺑ",
  "item.minecraft.filled_map": "ﻪﺸﻘﻧ□#0",
  "item.minecraft.shears": "ﺎﻫ یچیﻗ",
  "item.minecraft.melon_slice": "ﻪﻧﺍﻭﺪﻨﻫ چﺎﻗ",
  "item.minecraft.dried_kelp": "ﻩﺪﺷ کﺸﺧ یﻳﺎﻳﺭﺩ کﺒﻠﺟ",
  "item.minecraft.pumpkin_seeds": "ﻞﺒﻨﺗﻭﺪک ﻪﻧﺍﺩ",
  "item.minecraft.melon_seeds": "ﻪﻧﺍﻭﺪﻨﻫ ﺭﺬﺑ",
  "item.minecraft.beef": "ﻭﺎگ ﺖﺷﻮگ",
  "item.minecraft.cooked_beef": "ﻭﺎگ ﻪﺘﺨپ ﺖﺷﻮگ",
  "item.minecraft.chicken": "ﻡﺎﺧ ﻍﺮﻣ",
  "item.minecraft.cooked_chicken": "ﻍﺮﻣ ﻪﺘﺨپ ﺖﺷﻮگ",
  "item.minecraft.rotten_flesh": "ﻲﺒﻣﺍﺯ ﺖﺷﻮگ",
  "item.minecraft.ender_pearl": "ﻡﺎﺟﺮﻓ ﺮﻫﻮگ",
  "item.minecraft.blaze_rod": "ﻦﻴﺸﺗﺁ ﻪﻠﻴﻣ",
  "item.minecraft.ghast_tear": "ﺖﺴﹷگ کﺷﺍ",
  "item.minecraft.gold_nugget": "ﻼﻃ ﻩﺭﺫ",
  "item.minecraft.nether_wart": "ﺭﺪﻧ ﻞیگﺯ",
  "item.minecraft.potion": "ﺖﺧﺎﺳ ﻞﺑﺎﻗﺮﻴﻏ ﻥﻮﺠﻌﻣ□ﺽﺭﺍﻮﻋ ﻥﻭﺪﺑ",
  "item.minecraft.glass_bottle": "یﺍ ﻪﺸﻴﺷ یﺮﻄﺑ",
  "item.minecraft.spider_eye": "ﺕﻮﺒکﻨﻋ ﻢﺸچ",
  "item.minecraft.fermented_spider_eye": "ﻩﺪﺷ ﺮیﻤﺨﺗ ﺕﻮﺒکﻨﻋ ﻢﺸچ",
  "item.minecraft.blaze_powder": "ﺯﻭﺮﻓﺍ ﻪﻠﻌﺷ ﺭﺩﻮپ",
  "item.minecraft.magma_cream": "ﺎﻤگﺎﻣ پﻮﺗ",
  "block.minecraft.brewing_stand": "ﺯﺎﺳ ﻥﻮﺠﻌﻣ",
  "block.minecraft.cauldron": "گﻳﺩ",
  "item.minecraft.ender_eye": "ﻡﺎﺟﺮﻓ ﻢﺸچ",
  "item.minecraft.glistering_melon_slice": "ﻥﺎﺸﺧﺭﺩ ﻪﻧﺍﻭﺪﻨﻫ چﺎﻗ",
  "item.minecraft.bat_spawn_egg": "ﺵﺎﻔﺧ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.bee_spawn_egg": "ﺭﻮﺒﻧﺯ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.blaze_spawn_egg": "ﺯﻭﺮﻓﺍ ﻪﻠﻌﺷ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.cat_spawn_egg": "ﻪﺑﺮگ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.cave_spider_spawn_egg": "یﺭﺎﻏ ﺕﻮﺒکﻨﻋ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.chicken_spawn_egg": "ﻍﺮﻣ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.cod_spawn_egg": "یﻫﺎﻣ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.cow_spawn_egg": "ﻭﺎگ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.creeper_spawn_egg": "ﺮپﻳﺮک ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.dolphin_spawn_egg": "ﻦیﻔﻟﺩ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.donkey_spawn_egg": "ﻍﻻﺍ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.drowned_spawn_egg": "ﻩﺪﺷ ﻕﺮﻏ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.elder_guardian_spawn_egg": "ﺪﺷﺭﺍ ﻆﻓﺎﺤﻣ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.enderman_spawn_egg": "ﻦﻣﺭﺪﻧﺍ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.endermite_spawn_egg": "ﺖﻳﺎﻣﺭﺪﻧﺍ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.evoker_spawn_egg": "ﻩﺪﻨﻧﺍﻮﺧﺍﺮﻓ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.fox_spawn_egg": "ﻩﺎﺑﻭﺭ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.ghast_spawn_egg": "ﺖﺴﹷگ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.guardian_spawn_egg": "ﻆﻓﺎﺤﻣ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.hoglin_spawn_egg": "ﻦﻴﻠگﻮﻫ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.horse_spawn_egg": "ﺐﺳﺍ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.husk_spawn_egg": "کﺳﺎﻫ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.llama_spawn_egg": "ﺎﻣﻻ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.magma_cube_spawn_egg": "ﺎﻤگﺎﻣ ﺐﻌکﻣ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.mooshroom_spawn_egg": "ﻭﺎﻗ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.mule_spawn_egg": "ﺮﻃﺎﻗ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.ocelot_spawn_egg": "گﻨﻠپ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.panda_spawn_egg": "ﺍﺪﻧﺎپ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.parrot_spawn_egg": "یﻃﻮﻃ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.phantom_spawn_egg": "ﺢﺒﺷ ﺪیﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.pig_spawn_egg": "کﻮﺧ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.piglin_spawn_egg": "ﻦﻴﻠگﻴپ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.pillager_spawn_egg": "ﺮگﺗﺭﺎﻏ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.polar_bear_spawn_egg": "یﺒﻄﻗ ﺱﺮﺧ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.pufferfish_spawn_egg": "یکﻨکﺩﺎﺑ یﻫﺎﻣ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.rabbit_spawn_egg": "ﺵﻮگﺮﺧ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.ravager_spawn_egg": "ﺮگﺩﻮﺑﺎﻧ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.salmon_spawn_egg": "ﻥﻮﻤﻟﺎﺳ یﻫﺎﻣ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.sheep_spawn_egg": "ﺪﻨﻔﺳﻮگ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.shulker_spawn_egg": "ﺮکﻟﺎﺷ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.silverfish_spawn_egg": "ﺶﻴﻓﺭﻮﻠﻴﺳ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.skeleton_spawn_egg": "ﺖﻠکﺳﺍ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.skeleton_horse_spawn_egg": "یﺘﻠکﺳﺍ ﺐﺳﺍ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.slime_spawn_egg": "ﻢﻳﻼﺳﺍ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.spider_spawn_egg": "ﺕﻮﺒکﻨﻋ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.squid_spawn_egg": "ﺐکﺮﻣ یﻫﺎﻣ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.stray_spawn_egg": "یﺮﺘﺳﺍ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.strider_spawn_egg": "ﻥﺯﻡﺪﻗ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.trader_llama_spawn_egg": "ﺮگﻪﻠﻣﺎﻌﻣ ﺎﻣﻻ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.tropical_fish_spawn_egg": "یﻳﺍﻮﺘﺳﺍ یﻫﺎﻣ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.turtle_spawn_egg": "ﺖﺸپکﻻ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.vex_spawn_egg": "ﺲکﹺﻭ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.villager_spawn_egg": "یﻳﺎﺘﺳﻭﺭ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.vindicator_spawn_egg": "ﺯﺭﻭﻪﻨﻴک ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.wandering_trader_spawn_egg": "ﻥﺍﺩﺮگﺮﺳ ﺮگﻪﻠﻣﺎﻌﻣ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.witch_spawn_egg": "ﺮگﻭﺩﺎﺟ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.wither_skeleton_spawn_egg": "ﺭﺪﻳﻭ ﺖﻠکﺳﺍ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.wolf_spawn_egg": "گﺮگ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.zoglin_spawn_egg": "ﻦﻴﻠگﻭﺯ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.zombie_spawn_egg": "یﺒﻣﺍﺯ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.zombie_horse_spawn_egg": "یﺒﻣﺍﺯ ﺐﺳﺍ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.zombie_villager_spawn_egg": "یﻳﺎﺘﺳﻭﺭ یﺒﻣﺍﺯ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.zombified_piglin_spawn_egg": "ﻩﺪﺷ یﺒﻣﺍﺯ ﻦﻴﻠگﻴپ ﺪﻴﻟﻮﺗ ﻢﺨﺗ",
  "item.minecraft.experience_bottle": "ﻪﺑﺮﺠﺗ یﺮﻄﺑ",
  "item.minecraft.fire_charge": "ﺶﺗﺁ ﺕﺎﻤﻬﻣ",
  "item.minecraft.writable_book": "ﻢﻠﻗ ﻭ ﺏﺎﺘک",
  "item.minecraft.written_book": "ﻩﺪﺷ ﻪﺘﺷﻮﻧ ﺏﺎﺘک",
  "item.minecraft.emerald": "ﺩﺮﻣﺯ",
  "item.minecraft.item_frame": "ﺏﺎﻗ",
  "block.minecraft.flower_pot": "ﻥﺍﺪﻠگ",
  "item.minecraft.carrot": "ﺞﻳﻮﻫ",
  "item.minecraft.potato": "یﻨیﻣﺯ ﺐیﺳ",
  "item.minecraft.baked_potato": "ﻪﺘﺨپ یﻨیﻣﺯ ﺐیﺳ",
  "item.minecraft.poisonous_potato": "یﻤﺳ یﻨیﻣﺯ ﺐیﺳ",
  "item.minecraft.map": "یﻟﺎﺧ ﻪﺸﻘﻧ",
  "item.minecraft.golden_carrot": "یﻳﻼﻃ ﺞﻳﻮﻫ",
  "block.minecraft.skeleton_skull": "ﺖﻠکﺳﺍ ﻪﻤﺠﻤﺟ",
  "block.minecraft.wither_skeleton_skull": "ﺭﺪیﻭ ﺖﻠکﺳﺍ ﻪﻤﺠﻤﺟ",
  "block.minecraft.player_head": "ﻦکﻳﺯﺎﺑ ﺮﺳ",
  "block.minecraft.zombie_head": "یﺒﻣﺍﺯ ﺮﺳ",
  "block.minecraft.creeper_head": "ﺮپیﺮک ﺮﺳ",
  "block.minecraft.dragon_head": "ﺎﻫﺩژﺍ ﺮﺳ",
  "item.minecraft.carrot_on_a_stick": "ﻪﻠیﻣ یﻭﺭ ﺞﻳﻮﻫ",
  "item.minecraft.warped_fungus_on_a_stick": "ﺏﻼﻗ یﻭﺭ ﻩﺩﺭﻮﺧچیپ چﺭﺎﻗ",
  "item.minecraft.nether_star": "ﺭﺪﻧ ﻩﺭﺎﺘﺳ",
  "item.minecraft.pumpkin_pie": "ﻭﺪک کﻴک",
  "item.minecraft.firework_rocket": "ﻱﺯﺎﺒﺸﺗﺁ ﺖکﺍﺭ",
  "item.minecraft.firework_star": "ﺕﻭﺭﺎﺑ ﻪﻟﻮﻠگ",
  "item.minecraft.enchanted_book": "ﻩﺪﺷ ﻥﻮﺴﻓﺍ ﺏﺎﺘک",
  "item.minecraft.nether_brick": "ﺭﺪﻧ ﺮﺟﺁ",
  "item.minecraft.quartz": "ﺭﺪﻧ ﺰﺗﺭﺍﻮک",
  "item.minecraft.tnt_minecart": "ﻲﺗ ﻥﺍ ﻲﺗ ﺎﺑ ﻥﺪﻌﻣ ﻦﻴﺷﺎﻣ",
  "item.minecraft.hopper_minecart": "ﻒﻴﻗ ﺎﺑ ﻥﺪﻌﻣ ﻦﻴﺷﺎﻣ",
  "item.minecraft.prismarine_shard": "یﻳﺎﻳﺭﺩ ﺭﻮﺸﻨﻣ ﻪکﺗ",
  "item.minecraft.prismarine_crystals": "یﻳﺎﻳﺭﺩ ﺭﻮﺸﻨﻣ ﻝﺎﺘﺴیﺮک",
  "item.minecraft.rabbit": "ﻡﺎﺧ ﺵﻮگﺮﺧ ﺖﺷﻮگ",
  "item.minecraft.cooked_rabbit": "ﺵﻮگﺮﺧ ﻪﺘﺨپ ﺖﺷﻮگ",
  "item.minecraft.rabbit_stew": "ﺵﻮگﺮﺧ ﺵﺭﻮﺧ",
  "item.minecraft.rabbit_foot": "ﺵﻮگﺮﺧ یﺎپ",
  "item.minecraft.rabbit_hide": "ﺵﻮگﺮﺧ ﺖﺳﻮپ",
  "item.minecraft.armor_stand": "ﺵﻮپ ﻩﺭﺯ ﻪﻳﺎپ",
  "item.minecraft.iron_horse_armor": "یﻨﻫﺁ ﺐﺳﺍ ﻩﺭﺯ",
  "item.minecraft.golden_horse_armor": "ییﻼﻃ ﺐﺳﺍ ﻩﺭﺯ",
  "item.minecraft.diamond_horse_armor": "یﺳﺎﻤﻟﺍ ﺐﺳﺍ ﻩﺭﺯ",
  "item.minecraft.leather_horse_armor": "ﺐﺳﺍ یﻣﺮچ ﻩﺭﺯ",
  "item.minecraft.lead": "ﻩﺩﻼﻗ",
  "item.minecraft.name_tag": "ﺭﺍﺬگ ﻡﺎﻧ",
  "item.minecraft.command_block_minecart": "ﺭﻮﺘﺳﺩ کﻮﻠﺑ ﺎﺑ ﻥﺪﻌﻣ ﻦﻴﺷﺎﻣ",
  "item.minecraft.mutton": "ﻡﺎﺧ ﺪﻨﻔﺳﻮگ ﺖﺷﻮگ",
  "item.minecraft.cooked_mutton": "ﺪﻨﻔﺳﻮگ ﻪﺘﺨپ ﺖﺷﻮگ",
  "block.minecraft.white_banner": "ﺪﻴﻔﺳ ﻢچﺮپ",
  "block.minecraft.orange_banner": "یﺠﻧﺭﺎﻧ ﻢچﺮپ",
  "block.minecraft.magenta_banner": "یﻧﺍﻮﻏﺭﺍ ﻢچﺮپ",
  "block.minecraft.light_blue_banner": "ﻦﺷﻭﺭ یﺑﺁ ﻢچﺮپ",
  "block.minecraft.yellow_banner": "ﺩﺭﺯ ﻢچﺮپ",
  "block.minecraft.lime_banner": "ﻦﺷﻭﺭ ﺰﺒﺳ ﻢچﺮپ",
  "block.minecraft.pink_banner": "یﺗﺭﻮﺻ ﻢچﺮپ",
  "block.minecraft.gray_banner": "یﺮﺘﺴکﺎﺧ ﻢچﺮپ",
  "block.minecraft.light_gray_banner": "یﺍﻩﺮﻘﻧ ﻢچﺮپ",
  "block.minecraft.cyan_banner": "ﻦﺷﻭﺭ یﺑﺁ ﻢچﺮپ",
  "block.minecraft.purple_banner": "ﺶﻔﻨﺑ ﻢچﺮپ",
  "block.minecraft.blue_banner": "یﺑﺁ ﻢچﺮپ",
  "block.minecraft.brown_banner": "یﺍﻩﻮﻬﻗ ﻢچﺮپ",
  "block.minecraft.green_banner": "ﺰﺒﺳ ﻢچﺮپ",
  "block.minecraft.red_banner": "ﺰﻣﺮﻗ ﻢچﺮپ",
  "block.minecraft.black_banner": "ﻩﺎﻴﺳ ﻢچﺮپ",
  "item.minecraft.end_crystal": "ﻥﺎیﺎپ ﻝﺎﺘﺴیﺮک",
  "item.minecraft.chorus_fruit": "ﺮک ﻩﻮیﻣ",
  "item.minecraft.popped_chorus_fruit": "ﻩﺩﺮک ﻒپ ﺮک ﻩﻮیﻣ",
  "item.minecraft.beetroot": "ﺭﺪﻨﻐچ",
  "item.minecraft.beetroot_seeds": "ﺭﺪﻨﻐچ ﺭﺬﺑ",
  "item.minecraft.beetroot_soup": "ﺭﺪﻨﻐچ پﻮﺳ",
  "item.minecraft.dragon_breath": "ﺎﻫﺩژﺍ ﺲﻔﻧ",
  "item.minecraft.splash_potion": "ﺖﺧﺎﺳ ﻞﺑﺎﻗﺮﻴﻏ یﺑﺎﺗﺮپ ﻥﻮﺠﻌﻣ□ﺽﺭﺍﻮﻋ ﻥﻭﺪﺑ",
  "item.minecraft.spectral_arrow": "ﺮگﻧﺎﺸﻧ ﺮﻴﺗ",
  "item.minecraft.tipped_arrow": "ﺖﺧﺎﺳ ﻞﺑﺎﻗﺮیﻏ ﻩﺪﺷﻪﺘﺸﻏﺁ ﺮﻴﺗ□ﺽﺭﺍﻮﻋ ﻥﻭﺪﺑ",
  "item.minecraft.lingering_potion": "ﺖﺧﺎﺳ ﻞﺑﺎﻗﺮﻴﻏ ﺭﺎگﺪﻧﺎﻣ ﻥﻮﺠﻌﻣ□ﺽﺭﺍﻮﻋ ﻥﻭﺪﺑ",
  "item.minecraft.shield": "ﺮپﺳ",
  "item.minecraft.elytra": "ﺵﻮپ ﻝﺎﺑ",
  "item.minecraft.spruce_boat": "ﺝﺎک ﻖﻳﺎﻗ",
  "item.minecraft.birch_boat": "ﺱﻮﺗ ﻖﻳﺎﻗ",
  "item.minecraft.jungle_boat": "یﻠگﻨﺟ ﻖﻳﺎﻗ",
  "item.minecraft.acacia_boat": "ﺎﻴﻗﺎﻗﺍ ﻖﻳﺎﻗ",
  "item.minecraft.dark_oak_boat": "ﻩﺮﻴﺗ ﻁﻮﻠﺑ ﻖﻳﺎﻗ",
  "item.minecraft.totem_of_undying": "گﺮﻣ ﺩﺯ ﻪﻤﺴﺠﻣ",
  "item.minecraft.shulker_shell": "ﺮکﻟﺎﺷ ﻑﺪﺻ",
  "item.minecraft.iron_nugget": "ﻦﻫﺁ ﻪکﺗ",
  "item.minecraft.knowledge_book": "ﺶﻧﺍﺩ ﺏﺎﺘک",
  "item.minecraft.debug_stick": "یﺸک گﺎﺑ ﺏﻮچ",
  "item.minecraft.music_disc_13": "کﻳﺯﻮﻣ کﺴﻳﺩ□c418 - 13",
  "item.minecraft.music_disc_cat": "کﻳﺯﻮﻣ کﺴﻳﺩ□c418 - cat",
  "item.minecraft.music_disc_blocks": "کﻳﺯﻮﻣ کﺴﻳﺩ□c418 - blocks",
  "item.minecraft.music_disc_chirp": "کﻳﺯﻮﻣ کﺴﻳﺩ□c418 - chirp",
  "item.minecraft.music_disc_far": "کﻳﺯﻮﻣ کﺴﻳﺩ□c418 - far",
  "item.minecraft.music_disc_mall": "کﻳﺯﻮﻣ کﺴﻳﺩ□c418 - mall",
  "item.minecraft.music_disc_mellohi": "کﻳﺯﻮﻣ کﺴﻳﺩ□c418 - mellohi",
  "item.minecraft.music_disc_stal": "کﻳﺯﻮﻣ کﺴﻳﺩ□c418 - stal",
  "item.minecraft.music_disc_strad": "کﻳﺯﻮﻣ کﺴﻳﺩ□c418 - strad",
  "item.minecraft.music_disc_ward": "کﻳﺯﻮﻣ کﺴﻳﺩ□c418 - ward",
  "item.minecraft.music_disc_11": "کﻳﺯﻮﻣ کﺴﻳﺩ□c418 - 11",
  "item.minecraft.music_disc_wait": "کﻳﺯﻮﻣ کﺴﻳﺩ□c418 - wait",
  "item.minecraft.music_disc_pigstep": "کﻳﺯﻮﻣ کﺴﻳﺩ□lena raine - pigstep",
  "item.minecraft.trident": "کگﻨچ□□:ﺖﺳﺍ یﻠﺻﺍ ﺖﺳﺩ ﺭﺩ ﻪک یﻣﺎگﻨﻫ□ﺞﻴﻣﺩ8+□ﻪﻠﻤﺣ ﺖﻋﺮﺳ 2.9-",
  "item.minecraft.phantom_membrane": "ﺢﺒﺷ یﺎﺸﻏ",
  "item.minecraft.nautilus_shell": "ﺱﻮﻠیﺗﺎﻧ ﻑﺪﺻ",
  "item.minecraft.heart_of_the_sea": "ﺎیﺭﺩ ﺐﻠﻗ",
  "item.minecraft.crossbow": "یﺩﻻﻮپ ﻥﺎﻤک",
  "item.minecraft.suspicious_stew": "کﻮکﺸﻣ پﻮﺳ",
  "block.minecraft.loom": "یﺟﺎﺴﻧ کﻮﻠﺑ",
  "item.minecraft.flower_banner_pattern": "ﻢچﺮپ ﺡﺮﻃ□ژﺭﺎﺷ ﻞگ",
  "item.minecraft.creeper_banner_pattern": "ﻢچﺮپ ﺡﺮﻃ□ژﺭﺎﺷ ﺮپیﺮک",
  "item.minecraft.skull_banner_pattern": "ﻢچﺮپ ﺡﺮﻃ□ژﺭﺎﺷ ﻪﻤﺠﻤﺟ",
  "item.minecraft.mojang_banner_pattern": "ﻢچﺮپ ﺡﺮﻃ□ﺰﻴچ",
  "item.minecraft.globe_banner_pattern": "ﻢچﺮپ ﺡﺮﻃ□ﻩﺮک",
  "item.minecraft.piglin_banner_pattern": "ﻢچﺮپ ﺡﺮﻃ□ﻩﺯﻮپ",
  "block.minecraft.composter": "ﺯﺎﺳﺩﻮک",
  "block.minecraft.barrel": "ﻪکﺸﺑ",
  "block.minecraft.smoker": "ﺮکﻮﻤﺳﺍ",
  "block.minecraft.blast_furnace": "ﺏﻭﺫ ﻩﺭﻮک",
  "block.minecraft.cartography_table": "یﺸک ﻪﺸﻘﻧ ﺰیﻣ",
  "block.minecraft.fletching_table": "یﺯﺎﺳ ﺮیﺗ ﺰیﻣ",
  "block.minecraft.grindstone": "ﻩﺩﺎﺒﻤﺳ گﻨﺳ",
  "block.minecraft.lectern": "ﺖﺋﺍﺮﻗ ﺰیﻣ",
  "block.minecraft.smithing_table": "یﺮگﻨﻫﺁ ﺰیﻣ",
  "block.minecraft.stonecutter": "ﺵﺍﺮﺗ گﻨﺳ",
  "block.minecraft.bell": "ﺱﻮﻗﺎﻧ",
  "block.minecraft.lantern": "ﺱﻮﻧﺎﻓ",
  "block.minecraft.soul_lantern": "ﺡﻭﺭ ﺱﻮﻧﺎﻓ",
  "item.minecraft.sweet_berries": "ﻦیﺮیﺷ یﺎﻫ ﺕﻮﺗ",
  "block.minecraft.campfire": "ﺶﺗﺁ ﻩﺪﻨک",
  "block.minecraft.soul_campfire": "ﺡﻭﺭ ﺶﺗﺁﻩﺪﻨک",
  "block.minecraft.shroomlight": "یچﺭﺎﻗ ﻍﺍﺮچ",
  "item.minecraft.honeycomb": "ﻞﺴﻋ ﻡﻮﻣ",
  "block.minecraft.bee_nest": "ﻭﺪﻨک",
  "block.minecraft.beehive": "ﺭﻮﺒﻧﺯ ﻪﻧﻻ",
  "item.minecraft.honey_bottle": "ﻞﺴﻋ یﺮﻄﺑ",
  "block.minecraft.honey_block": "ﻞﺴﻋ کﻮﻠﺑ",
  "block.minecraft.honeycomb_block": "ﻞﺴﻋ ﻡﻮﻣ کﻼﺑ",
  "block.minecraft.lodestone": "ﺶﻌﺗﺮﻣ گﻨﺳ",
  "block.minecraft.netherite_block": "ﺖﻳﺍﺭﺪﻧ کﻮﻠﺑ",
  "block.minecraft.ancient_debris": "یﻧﺎﺘﺳﺎﺑ یﺎﻫ ﻪﻘﻴﺘﻋ",
  "block.minecraft.target": "ﻑﺪﻫ",
  "block.minecraft.crying_obsidian": "ﻥﺎﻳﺮگ ﻥﺎﻳﺪﻴﺴﺑﺁ",
  "block.minecraft.blackstone": "گﻨﺳﻩﺎﻴﺳ",
  "block.minecraft.blackstone_slab": "گﻨﺳﻩﺎﻴﺳ کﻼﺑﻢیﻧ",
  "block.minecraft.blackstone_stairs": "گﻨﺳﻩﺎﻴﺳ یﻪﻠپ",
  "block.minecraft.gilded_blackstone": "ﻩﺪﺷ ﺐیﻫﺬﺗ گﻨﺳﻩﺎﻴﺳ",
  "block.minecraft.polished_blackstone": "یﻠﻘﻴﺻ گﻨﺳﻩﺎﻴﺳ",
  "block.minecraft.polished_blackstone_slab": "یﻠﻘﻴﺻ گﻨﺳﻩﺎﻴﺳ کﻼﺑﻢیﻧ",
  "block.minecraft.polished_blackstone_stairs": "یﻠﻘﻴﺻ گﻨﺳﻩﺎﻴﺳ یﻪﻠپ",
  "block.minecraft.chiseled_polished_blackstone": "ﻩﺩﺭﻮﺧﺵﺍﺮﺗ یﻠﻘﻴﺻ گﻨﺳﻩﺎﻴﺳ ﺮﺟﺁ",
  "block.minecraft.polished_blackstone_bricks": "یﻠﻘﻴﺻ گﻨﺳﻩﺎﻴﺳ ﺮﺟﺁ",
  "block.minecraft.polished_blackstone_brick_slab": "یﻠﻘﻴﺻ گﻨﺳﻩﺎﻴﺳ ﺮﺟﺁ کﻼﺑﻢیﻧ",
  "block.minecraft.polished_blackstone_brick_stairs": "یﻠﻘﻴﺻ گﻨﺳﻩﺎﻴﺳ ﺮﺟﺁ یﻪﻠپ",
  "block.minecraft.cracked_polished_blackstone_bricks": "ﻩﺩﺭﻮﺧکﺮﺗ یﻠﻘﻴﺻ گﻨﺳﻩﺎﻴﺳ ﺮﺟﺁ",
  "block.minecraft.respawn_anchor": "ﺩﺪﺠﻣ ﺭﺎﻀﺣﺍ ﻪﻳﺎپ",
}
export const fa_ir = items; 
